window.languages = window.languages || {};

var cn = {
    "STATIC": {
        "APP": "应用",
        "POPOVERS": {
            "FIRST_APP_ADDED": {
                "CONGRATS": "步骤 1 完成！继续...",
                "MESSAGE": "下一步：将 Singular SDK 集成到您的产品中。\n还没准备好吗？可以选择先从数据连接器开始",
                "BUTTON": "集成SDK",
                "ALTERNATIVE_BUTTON": "添加数据连接器"
            },
            "ADD_MORE_PLATFORM": {
                "CONGRATS": "开局不错！这个应用应该还有其他平台版本吧...",
                "MESSAGE": "您已成功添加第一个应用 \n该应用还有其他操作系统版本吗（例如 iOS、Android、Web）？",
                "ADD_ANOTHER_PLATFORM_BUTTON": "添加另一个平台",
                "ONLY_ONE_PLATFORM_BUTTON": "我只有一个平台"
            }
        },
        "BUTTONS": {
            "ADD": "添加",
            "ADD_NEW_DIMENSIONS": "添加新自定义维度",
            "APPLY": "应用",
            "BACK": "返回",
            "BOOKMARK": "书签",
            "CANCEL": "取消",
            "CLEAR_SELECTION": "初始化选项",
            "COMPARE_TWO_PERIODS": "对比两个期间",
            "CONTINUE": "继续",
            "COPIED": "已复制",
            "COPY": "复制",
            "CREATE_GOAL": "创建目标",
            "TEAM_USERS_CREATE_NEW_MEMBER": "创建新用户",
            "DATEPICKER": {
                "CUSTOM": "自定义",
                "FROM": "从",
                "LAST_30_DAYS": "过去30天",
                "LAST_7_DAYS": "过去7天",
                "LAST_MONTH": "上个月",
                "PREVIOUS_PERIOD": "前一个期间",
                "SAME_PERIOD_LAST_YEAR": "去年同期",
                "THIS_MONTH": "这个月",
                "THIS_QUARTER": "这个季度",
                "TO": "到",
                "TODAY": "今天",
                "YESTERDAY": "昨天"
            },
            "DEACTIVATE_TWO_FACTOR_AUTH": "撤销双重认证",
            "DELETE": "删除",
            "DELETE_CELL": "删除单元",
            "DISABLE": "撤销",
            "EDIT_REPORT": "编辑报表",
            "EDIT_TAGS": "编辑标签",
            "EXPORT": "导出报告",
            "EXPORT_CSV": "导出CSV样本文件",
            "EXPORT_JSON": "导出JSON文件",
            "EXPORT_RAW_CSV": "原始数据",
            "GENERATE": "生成",
            "GOAL_REPORT_TAB": "目标",
            "HIDE_CHART": "隐藏曲线图",
            "HIDE_LEGEND": "隐藏图例",
            "IMAGE": "图片",
            "IMAGE_AND_TEXT": "图片与文字",
            "LEGEND_TOGGLE": "图例",
            "NETWORK": "媒体网络",
            "NEW_ALERT": "新提醒",
            "NEW_CUSTOM_DIMENSION": "新自定义维度",
            "NEW_CUSTOM_EVENT": "新自定义事件",
            "NEW_CUSTOM_METRIC": "新自定义指标",
            "NEW_GOAL": "新目标",
            "NEXT": "下一步",
            "PRESS_GENERATE": "点击生成",
            "REGULAR_REPORT_TAB": "报表",
            "REMOVE": "移除对比",
            "RUN": "运行报告",
            "SAVE": "保存",
            "SAVE_AND_ADD_ANOTHER": "保存并添加另一个",
            "SETUP_TWO_FACTOR_AUTH": "设置双重认证",
            "SHARE": "分享报告",
            "SHOW_CHART": "显示曲线图",
            "SHOW_LEGEND": "显示图例",
            "SUBMIT": "提交",
            "TEXT": "文字",
            "TRACKER": "归因工具",
            "UNENRICHED": "未匹配",
            "FINISH": "完成", 
            "TOGGLE": {
                "NO": "否",
                "YES": "是"
            },
        },
        "CAMPAIGN": "广告系列",
        "CLUSTERING": "群聚",
        "COHORT_METRICS": "群组指标",
        "COHORT_PERIOD": "群组期间",
        "COHORT_PERIODS": "群组期间",
        "CUSTOM_DIMENSIONS": "自定义维度",
        "CUSTOM_EVENTS": "自定义事件",
        "DESTINATION": "链接落地页",
        "DIMENSIONS": "维度",
        "FILTERS": "过滤选项",
        "GENERAL_ERROR_DIALOG_TEXT": "出错了...请刷新页面重新尝试",
        "GENERAL_ERROR_DIALOG_TITLE": "出错了...请刷新页面重新尝试",
        "GOAL_FORECAST": "目标完成度预测",
        "GOAL_METRICS": "目标指标",
        "LINK_EXPIRATION_IN_DAYS": "设置链接有效期",
        "LINK_URL": "链接URL",
        "MANAGE_TEAM": "用户授权和管理",
        "METADATA_DIMENSIONS": "投放竞价指标",
        "METRICS": "指标",
        "SOURCE": "伙伴",
        "PLATFORM": "平台",
        "DAU_METRICS": "User Activity Metrics",
        "MISSING_DASHBOARD_DATA": "所选取的指标下没有可以匹配的数据",
        "MODAL_HEADERS": {
            "ADD_SOURCE": "添加媒体渠道",
            "CHANGE_PASSWORD": "修改密码"
        },
        "GO_BACK_PANEL": {
            "GO_BACK_TO_ONBOARDING_GUIDE": "点击回到主界面",
        },
        "PAGES": {
            "ALERTS": {
                "LEARN_MORE": "<a href=\"https://singular.zendesk.com/hc/en-us/articles/207429293-How-to-Use-Alerts-Part-1-Overview-FAQs\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">点击了解更多</a>",
                "NEW_ALERT": "新提醒",
                "NOTE": "注意：当渠道数据符合要求的时候才会触发提醒",
                "NO_ALERTS": "尚未创建新提醒",
                "P1": "创建提醒，当各项指标的变动满足预设条件时可以收到邮件提醒，以进行优化操作"
            },
            "SKADNETWORK": {
                "SKAN_PLUS_CHIP_TOOLTIP": {
                    "OPTIMIZED_MODEL": 'SKAN+ 模型推荐已应用',
                    "UNOPTIMIZED_MODEL": 'SKAN+ 模型推荐可用'
                },
            },
            "ANONYMOUS": {
                "ERROR_EXPIRED": "该报表已过期，请联系账户负责人重新共享报表",
                "ERROR_INVALID": "无效报表",
                "ERROR_INVALID_EMAIL": "输入的密码错误",
                "MODAL_LABEL": "密码",
                "MODAL_PLACEHOLDER": "请输入密码",
                "MODAL_TITLE": "查看共享报告"
            },
            "SHARED_REPORTS": {
                "SHELF_TITLE": "已分享的报告",
                "NOTE": "持有链接的人可以查看当前报表上的所有数据，建议在分享链接前确认报表上是否有需要保密的数据。" +
                    "<br/> Learn more in the <a href=\"https://support.singular.net/hc/zh-cn/articles/360046877232\" style=\"font-weight: 400 \" target=\"_blank\">Shared Reports FAQ</a>.",
                "GENERATE_REPORT_SECTION_HEADER": "生成共享报告链接",
                "REPORT_NAME": "报告名称:",
                "REPORT_NAME_HINT": "输入一个名称",
                "PASSWORD": "为分享链接设置密码（推荐）:",
                "PASSWORD_HINT": "输入密码",
                "DATES": "指定的期间:",
                "SPECIFY_DATE_RANGE_FALSE": "只显示指定期间的数据",
                "SPECIFY_DATE_RANGE_TRUE": "允许收到共享链接的人调整报告期间",
                "LINK_EXPIRATION": "设置链接有效期：",
                "GENERATED_LINKS": "已生成的链接 ",
                "NO_EXISTING_REPORTS": "尚未生成任何分享报告",
                "EMPTY_STATE": "尚未创建共享报告。请先在后台运行一个报告，然后进行分享。",
                "EXPIRES": "链接有效至",
                "DELETE_REPORT": "删除链接",
                "OPEN_REPORT_IN_SINGULAR": "通过Singular后台运行该报告",
                "COPY_BUTTON": "复制链接地址",
                "CLOSE": "关闭",
                "LINK_UNIT": "天",
                "GENERATE_LINK_BUTTON": "为当前报表生成链接",
            },
            "API": {
                "REPORTING_API_KEY": {
                    "DESC1": "当使用API接口时，需要用到以下API密钥。</br>请勿公示改密钥，以避免信息泄漏！",
                    "DESC2": "<strong>请注意：</strong> 该密钥不是对接Singular SDK时用到的密钥。",
                    "DESC3": "详情请参考 <a href=\"https://developers.singular.net/reference#reporting\" target=\"_blank\">API文档</a>",
                    "KEY": "密钥",
                    "TITLE": "报表数据API接口密钥"
                },
                "SDK_API_KEY": {
                    "DESC1": "在对接SDK时，需要用到以下SDK密钥。",
                    "NOTE": "<strong>请注意：</strong> 该密钥不是使用报表数据API时用到的密钥。",
                    "TITLE": "SDK API密钥"
                }
            },
            "APPS_CONFIGURATION": {
                "ADD_SITE": "添加应用版本",
                "ANDROID_INSTALL_VALIDATION_KEY": "谷歌商店许可密钥",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE": "屏蔽无效收益",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE_DISABLED": "关闭状态",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE_ENABLED": "启用日期",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE_TOOLTIP": "启用该项后，系统将会屏蔽缺失商店购买信息的IAP事件。请确保在启用该功能前，已对IAP追踪做了接收商店购买信息的相关配置，否则系统将屏蔽所有IAP事件，详情请参见<a target=\"_blank\" href=\"https://support.singular.net/hc/en-us/articles/360035996792?flash_digest=8ba73a31f9fcdeea4ce829a419f25a40bd1a3b67#enforcement\">帮助中心。</a>",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE_WARNING": "启用该选项后，针对启用后安装应用和更新应用的用户，系统会过滤所有缺失商店购买信息的收益事件。请谨慎考虑后决定是否启用。",
                "ANDROID_PURCHASE_ENFORCEMENT_DATE_WARNING_HEADER": "警告：确定要屏蔽缺失商店购买信息的收益事件么？",
                "ANDROID_SPECIFIC": "安卓深度链接",
                "ATTRIBUTION_CONFIGURATION": "归因设置",
                "CERTIFICATE_KEY": "证书密钥",
                "DEEPLINK_EXPLANATION_TITLE": "请使用{{os_type}}为{{os}}应用开启深度链接，详情请参见<a href=\"https://support.singular.net/hc/zh-cn/articles/360031371451-Singular-Links-Prerequisites\" target=\"_blank\">帮助中心。</a>",
                "DEEP_LINK_TARGETS": "深度链接URL",
                "DEFAULT_STORE_URL": "默认落地页为商店URL",
                "DESTINATIONS": "落地页设置",
                "DESTINATION_URLS": "落地页URL设置",
                "DOMAIN_NAME_PREFIX": "域名前缀",
                "DRAG_OR_CLICK_TO_UPLOAD_P12": "拖入或上传证书（.p12 格式文档）",
                "DROP_TO_UPLOAD_P12": "拖入证书以上传",
                "FCM_SERVER_KEY": "FCM服务器密钥",
                "FRAUD_OPTIONS": "IAP认证设置",
                "GCM_DEPRECATION_TOOLTIP": "谷歌已于2019年5月开始停止GCM推送服务并由FCM代替GCM进行全面的消息推送服务，请考虑升级到FCM，详情请参见<a target=\"_blank\" href=\"https://developers.google.com/cloud-messaging/android/android-migrate-fcm\">谷歌官宣。</a>对于尚未升级到FCM的广告主用户，仍可以在此输入GCM键值进行卸载追踪。",
                "IOS_PUSH_CERTIFICATE": "iOS Push证书",
                "IOS_UNIVERSAL_LINKS": "iOS通用链接",
                "IOS_UNIVERSAL_LINK_TARGETS": "通用链接URL",
                "KEYWORD": "匹配密钥",
                "LATEST_SDK_VERSION": "上次对接的SDK版本",
                "MOVE_TO": "移到…",
                "NOT_INTEGRATED": "尚未对接",
                "NO_APPS_CONFIGURED_DEVELOPMENT": "无匹配搜索内容的测试应用，请重新搜索或添加新应用",
                "NO_APPS_CONFIGURED_PRODUCTION": "无匹配搜索内容的应用，请重新搜索或添加新应用",
                "NO_DEEP_LINKS_CONFIGURED": "尚未创建深度链接，请添加URL",
                "NO_IOS_UNIVERSAL_LINKS_CONFIGURED": "尚未创建通用链接，请添加URL",
                "PACKAGE_IDENTIFIER": "包名",
                "PLACEHOLDERS": {
                    "APP_NAME": "应用名称",
                    "CHOOSE_PLATFORM": "选择平台",
                    "OPTIONAL": "（可选项）"
                },
                "SDK_INTEGRATED": "已检测到应用内事件",
                "SDK_NOT_INTEGRATED": "尚未检测到应用内事件",
                "SDK_STATUS": "SDK对接状态：",
                "SITE_NICKNAME": "自定义应用名称",
                "STORE_ID": "商店URL",
                "STORE_URL": "商店URL（推荐登陆方式）",
                "UNINSTALL_TRACKING": "卸载追踪"
            },
            "ATTRIBUTION": {
                "CONFIRM_MESSAGE_SEND": "需要将详细内容发送给我们的客户经理么？",
                "CONTACT_US": "联系我们",
                "MESSAGE_SENT": "信息已发送。我们的客户经理会尽快联系您。",
                "PAGE_DESCRIPTION": "借助Singular归因解决方案，揭示用户行为和分析广告渠道效果。",
                "SEND_MESSAGE": "发送信息"
            },
            "AUDIENCES": {
                "CONFIGURE_NETWORK": "配置媒体伙伴",
                "CREATE_NEW": "创建新用户群组",
                "DELETE_WARNING": "确定删除该用户群组？",
                "EDIT_SEGMENT": "编辑用户群组",
                "ENABLE_SEGMENT_DISTRIBUTION_TOGGLE_LABEL": "启用该用户群组",
                "HELP_DISTRIBUTIONS": "利用群组推送功能将已生成的<a href=\"#/react/audiences/segments\" class=\"link-underline\">目标用户群组</a>推送给我们的媒体伙伴。请在下面选择一个媒体伙伴进行配置。",
                "HELP_SEGMENTS": "利用创建群组功能从事件数据中筛选出目标用户，并通过<a href=\"#/react/audiences/distributions\" class=\"link-underline\">群组推送功能</a>将目标用户推送给我们的媒体伙伴。",
                "NEW_SEGMENT": "新用户群组",
                "OFF": "停用",
                "ON": "启用",
                "SEARCH_DISTRIBUTIONS": "检索已创建的推送",
                "SEARCH_SEGMENTS": "检索已创建的用户群组",
                "SEGMENTS_COUNT": "已创建的群组 (${activeSegmentsCount} active)",
                "SEGMENT_TEMPLATES": "用户群租模版",
                "SHARING_OPTIONS": "共享该用户群组",
                "SHARING_OPTIONS_COPY_TOOLTIP": "复制链接",
                "SHARING_OPTIONS_RENAME_TOOLTIP": "重命名",
                "SHARING_OPTIONS_REVOKE_TOOLTIP": "撤销链接",
                "SHARING_OPTIONS_SHELF_CREATE": "创建链接",
                "SHARING_OPTIONS_SHELF_CREATE_EMPTY": "创建链接",
                "SHARING_OPTIONS_SHELF_EMPTY": "请创建一个链接",
                "SHARING_OPTIONS_SHELF_TITLE": "对于尚未和Singular完成对接的媒体渠道，可以通过链接将用户群组分享给渠道。也可以根据需要撤销已生成的链接。",
                "UNSAVED_MESSAGE": "现在离开的话，系统将不会保存配置。"
            },
            "CUSTOM_DIMENSIONS": {
                "ADD_VALUE": "添加条件",
                "DELETE_MESSAGE": "确定要删除该自定义维度么？<br/>确认后系统会在账户级别删除该维度，并不可恢复。",
                "DELETE_WARNING": "进行此操作会将该自定义维度连同与其匹配的历史数据一并删除<br/>请确认是否删除？",
                "IF_NO_VALUE_MATCHED_SET_DEFAULT_TO": "当没有满足条件的数据时，指定一个用来显示的默认数据值: <em>例如 N/A</em>",
                "PLACEHOLDERS": {
                    "FILTER_DIMENSION": "选择一个维度"
                },
                "PREAMBLE": "对数据进行自定义分类和聚合，以进行更简单、更全面的数据分析。<a href=\"https://singular.zendesk.com/hc/en-us/articles/208579346-Creating-Custom-Dimensions\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">点击了解更多</a>",
                "USE_VALUE_WHEN": "当满足下列条件时，聚合数据到该自定义维度",
                "VALUE_DELETE_HOVER_TEXT": "删除子维度",
                "VALUE_NAME": "子维度名称",
                "WARNING_MAXIMUM_REACHED": "每个企业账户最多支持{{max}}个自定义维度"
            },
            "CUSTOM_EVENTS": {
                "ADD_CALCULATED_METRIC_BASED_ON_EVENT": "为自定义事件添加附加指标",
                "APP_SELECTION_AUTOCOMPLETE_PLACEHOLDER": "选择一个应用",
                "APP_SPECIFIC_CONT": "应用级别自定义事件 (${number})",
                "APP_SPECIFIC_EVENTS": "应用级别自定义事件",
                "EMPTY_STATE_NO_APP_SELECTED": "请选择一个应用",
                "EMPTY_STATE_NO_CUSTOM_EVENTS_FOR_APP": "尚无已配置的应用级别自定义事件",
                "EMPTY_STATE_NO_UAN_EVENTS": "找不到已追踪的SDK事件",
                "EVENTS_CONT": "已配置的账户级别自定义事件(${number})",
                "EVENT_DATA_NOTE": "请注意系统会检索过去1个月内侦测到的SDK事件",
                "GLOBAL_EVENTS": "通用自定义事件",
                "GLOBAL_EVENTS_CONT": "账户级别通用自定义事件 (${number})",
                "HELP": "了解更多内容请点击 <a href=\"https://singular.zendesk.com/hc/en-us/articles/208385833\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">帮助中心</a>",
                "HELP_TOOLTIP": "CPE = Cost/Event.<br>ECVR = events/installs.<br>选择后，系统会自动按照自定义事件名称将以上指标添加到报表中。",
                "LAST_MODIFIED": "最后编辑时间 {{date}}, 由 {{editor}} 用户生成",
                "LAST_MODIFIED_AUTOMATICALLY": "最后编辑时间 {{date}}, 系统自动生成的默认自定义事件",
                "MAP_TO": "该自定义事件所匹配的SDK事件",
                "MAP_TO_REACT": "该自定义事件所匹配的SDK事件",
                "MAP_TO_REACT_UNIQUE": "该自定义事件所匹配的SDK事件（只显示用户基准事件）",
                "NEAR_MAXIMUM_GLOBAL_WARNING": "请注意该账户下某一个应用所属的自定义事件已经达到${maxAppEvents}个，当账户内任意一个应用所属的自定义事件数超过上限额度${maxEvents}时，将无法再配置账户级别的通用自定义事件。",
                "NO_EVENTS": "尚未配置自定义事件",
                "PLACEHOLDERS": {
                    "EVENT_NAME": "定义自定义事件名称"
                },
                "REACHED_MAXIMUM_GLOBAL_WARNING": "该账户下某一个应用所属的自定义事件数量已达到上限额度${maxEvents} ，要添加账户级别的通用自定义事件，须确保为该账户下每个应用所属的自定义事件少于上限额度<br/>系客服 获取更多帮助。",
                "REACHED_MAXIMUM_WARNING": "该应用所属的自定义事件数量已达到上限额度${maxEvents}，无法在添加更多自定义事件。",
                "SAVE_SERVER_ERROR": "系统处理该请求时发生错误，请稍后重新尝试。",
                "UNIQUE_TOGGLE_DISABLE_INFO": "该自定义事件已被定义为 ${eventType} 类型",
                "UNIQUE_TOGGLE_INFO": "启用后，系统会按照用户基准对自定义事件进行排重统计",
                "UNIQUE_TOGGLE_LABEL": "用户基准自定义事件",
                "UNSAVED_CHANGES_WARNING": "尚未保存，确认离开么？"
            },
            "DASHBOARD": {
                "PREAMBLE": "了解更多内容，请点击 <a href=\"https://support.singular.net/hc/zh-cn/articles/206241026-Dashboard-FAQ\" class=\"link-underline\" target=\"_blank\" >帮助中心</a>"
            },
            "DATA_SOURCES": {
                "ADD_NEW": "添加新渠道",
                "ADD_NEW_CONNECTOR": "添加新渠道",
                "ADNETWORK_SELECTION_PLACEHOLDER": "选择渠道",
                "DELETE_UAN_ACTION": "${uan_name}已删除",
                "EDIT_UAN_TOOLTIP": "编辑",
                "EXPORT_RAW_DATA": "导出CSV文件",
                "GROUP_TITLES": {
                    "Action Required": "需要修改设置",
                    "Pending Integration": "系统确认中"
                },
                "HEADER_TEXT": "系统会在渠道登陆后的24小时内更新数据。在系统确认所添加的渠道信息无误后，即开始从媒体渠道方拉取过往3个月内的投放信息。",
                "HELP_CENTER": "帮助中心",
                "LAST_LOGIN": "最后登陆",
                "LAST_SUCCESSFUL_LOGIN": "最后成功登陆",
                "NEW_UAN_ACTION": "${uan_name}已添加",
                "NO_DATA": "尚无可展示的数据",
                "NO_DATA_CONNECTORS": "尚未配置渠道",
                "NO_SEARCH_RESULTS": "未找到可以匹配${searchText}的渠道",
                "PLACEHOLDERS": {
                    "ADD_DATA_SOURCE": "输入需要添加的渠道"
                },
                "REAUTHORIZE": "重新授权",
                "RUN_TEST_REPORT_TOOLTIP": "运行测试报告",
                "SETTINGS": {
                    "ACCOUNTS_ACTIVATE": {
                        "AUTOMATICALLY": "当该账户内有新的子账户时，自动勾选子账户",
                        "TITLE": "选择需要添加的子账户"
                    },
                    "GENERAL": {
                        "TITLE": "一般设置"
                    }
                },
                "SUBHEADER": "更多关于渠道配置和管理的内容，请点击<a target='_blank' href=\"https://support.singular.net/hc/zh-cn/articles/360031000051-Data-Connectors-FAQ\">帮助中心</a>",
                "TOGGLE_ARCHIVED_UANS": "显示近30天内未有更新数据的渠道",
                "TYPE_CONNECTOR_NAME": "检索渠道名称",
                "TYPE_SOURCE_NAME": "检索渠道名称",
                "WARNING": "请验证登陆信息"
            },
            "DELETE_MODAL": {
                "DELETE_NO": "否，我要撤回该操作",
                "DELETE_YES": "是，请删除{{deleteType}}",
                "DELETE_YES_REACT": "是，请删除${deleteType}",
                "TYPES": {
                    "PARTNER_CONFIG": "设置媒体渠道"
                },
                "WARNING_P1": "确定要删除这个{{deleteType}}?",
                "WARNING_P2": "系统会在账户级别进行该操作，并且不可逆。"
            },
            "EXPORT_LOGS": {
                "APP": "应用",
                "CONVERSION_TYPE": "转化类型",
                "CONVERSION_TYPES": {
                    "ALL": "全部",
                    "INSTALL": "安装",
                    "REENGAGEMENT": "再营销"
                },
                "COUNTRIES": "国家",
                "DATE": "日期",
                "DAYS_ERROR_MSG": "所选日期期间 ({{diff}} days) 超过期间限制 {{limit}} days",
                "ERROR_MSG": "请重新确认请求",
                "EVENTS": "事件",
                "EXPORT": "下载原始数据",
                "LEAVE_EMPTY_FOR_ALL": "无内容则默认下载全部",
                "PARTNERS": "投放渠道",
                "PLACEHOLDERS": {
                    "ADD_COUNTRIES": "请输入要选择的国家",
                    "ADD_DEVICE_TYPE": "请输入要选择的设备类型",
                    "ADD_EVENTS": "请输入要选择的应用内事件",
                    "ADD_PARTNERS": "请输入要选择的媒体渠道"
                },
                "POSTBACK_TYPE": "回传类型",
                "REALTIME_DATA_TOOLTIP": "如果勾选，所下载的原始数据将包含最近60分钟内收集的数据。",
                "SITE": "选择应用版本",
                "TIMEZONE": "已指定的时区",
                "TYPE": "选择数据类型",
                "TYPES": {
                    "Clicks": "点击",
                    "Events": "事件",
                    "Fps": "假量",
                    "Installs": "安装",
                    "Postbacks": "回传"
                }
            },
            "GENERATE_SMART_LINK": {
                "CUSTOM_SOURCE_NAME_NOTE": "<strong>注意</strong>: 如果选择使用自定义渠道名称，链接生成时渠道名称会以'(Custom)'为后缀",
                "GENERAL_SECTION": "基本设置",
                "OTHER_PLATFORMS": "其它应用版本",
                "PLACEHOLDER": {
                    "CUSTOM_NAME": "输入自定义渠道名称",
                    "DESTINATION": "请选择落地页",
                    "SELECT_APP_FIRST": "请选择应用"
                },
                "SMART_DESTINATION_DEPPLINK_LABEL": "${platform} 深度连接",
                "SMART_DESTINATION_UNIVERSAL_LINK_LABEL": "${platform} 通用链接",
                "SOURCES": {
                    "CROSSPROMO": "交叉推广",
                    "CUSTOM": "自定义",
                    "EMAIL": "邮件",
                    "SMS": "短信",
                    "SOCIAL": "社交"
                },
                "SUB_HEADER": "创建一个自定义跟踪链接，以实现在用户点击链接后，按照用户的设备类型，页面会自动跳转到到苹果商店、谷歌商店或者其它第三方商店。",
                "TIP": "针对已和Singular完成对接的渠道，需要在“创建跟踪链接”页面生成跟踪链接",
                "TIP2": "可以“应用设置”页面里添加更多落地页"
            },
            "GENERATE_TRACKING_LINK": {
                "ATTRIBUTION_SETTINGS": "归因设置",
                "CAMPAIGN_NAME": "跟踪链接名称",
                "CAMPAIGN_NAME_TOOLTIP": "为了避免在匹配数据时产生问题，建议按照“应用_OS_国家_附加信息”的样式来命名跟踪连接，例如：appname_ios_us_20200103",
                "CLICK_THROUGH_LINK": "点击型跟踪链接",
                "CONFIG": "配置",
                "CREATIVE_NAME": "素材名称",
                "DEEPLINK_DESTINATION_URL": "深度链接落地页URL",
                "DESTINATION_URL": "落地页URL",
                "GENERATE_LINK": "生成链接",
                "GENERATING_SHORT_LINK_ERROR": "在生成短链接时产生了错误",
                "GENERATING_TRACKING_LINK_ERROR": "在生成跟踪链接时产生了错误",
                "MODAL": {
                    "ALLOW_NO_POSTBACKS_NETWORKS": "一些媒体不仅需要自己渠道带来的安装回传，也需要其它渠道以及自然安装的回传来优化广告投放。勾选已开启全部安装回传给改渠道。",
                    "CLICK_THROUGH_ATTRIBUTION_WINDOW": "配置点击归因窗口",
                    "ENABLE_FRAUD_POSTBACKS": "针对被屏蔽的假量，开启回传",
                    "ENABLE_INTEGRATION": "启用归因追踪",
                    "ENABLE_REENGAGEMENT": "针对再营销广告，开启回传",
                    "ENABLE_REENGAGEMENT_TRACKING": "针对再营销广告，开启跟踪",
                    "ENABLE_VIEWTHROUGH": "针对无点击的广告曝光归因，开启回传",
                    "ENABLE_VIEWTHROUGH_TRACKING": "针对无点击的广告曝光归因，开启跟踪",
                    "GOT_IT": "已了解",
                    "INCLUDE_VIEWTHROUGH_ATTRIBUTIONS": "启用展示归因",
                    "INCLUDE_VIEWTHROUGH_ATTRIBUTIONS_TOOLTIP": "启用后，安装回传会包含归因为广告点击和展示的安装信息。",
                    "INSTALL_POSTBACK_CONFIGURATION": "安装回传设置",
                    "PLEASE_ENTER_EVENT": "请输入一个事件名称",
                    "PLEASE_SELECT_EVENT": "请选择一个事件",
                    "PLEASE_SELECT_EVENT_NAME": "请输入一个有效的 {{eventname}}",
                    "SEND_ALL_POSTBACKS_TO_ADN": "将所有安装回传给 {{adnname}}",
                    "SEND_IN_APP_EVENTS_TO": "将应用内事件回传给 {{adnname}}",
                    "SEND_POSTBACK_FOR_ALL_EVENTS": "针对所有事件发送回传",
                    "SEND_REVENUE": "发送收益数据",
                    "SEND_REVENUE_DISABLED_TOOLTIP": "自定义回传链接启用时此选项不能改变",
                    "SEND_REVENUE_TOOLTIP": "仅适用于购买事件",
                    "SNAPCHAT_ENABLE_INTEGRATION_EXPLANATION": "如需继续操作, 请阅读并同意 <a href=\"https://businesshelp.snapchat.com/en-US/article/attribution-terms\" target=\"_blank\">Snap Inc.'s Terms and Conditions</a>.",
                    "SOURCE_CONFIG_EDIT_POSTBACK_CAMPAIGN_REGEX": "归因广告活动的名字筛选",
                    "SOURCE_CONFIG_EDIT_POSTBACK_CAMPAIGN_REGEX_TOOLTIP": "设定之后，已归因的回传只会触发 安装",
                    "PARTNER_MANAGE_USERS": "管理{{adnname}}用户",
                    "PARTNER_ADD_LOGIN_EXPLANATION": "添加{{adnname}}账号并开启转化追踪",
                    "PARTNER_ADD_ACCOUNTS": "{adnname}} 广告账户",
                    "PARTNER_ADD_ACCOUNTS_EXPLANATION": "选择需要追踪归宗转化的{{adnname}}账户",
                    "TWITTER_EDIT_AD_ACCOUNTS": "编辑Twitter广告账户",
                    "TWITTER_ENABLE_INTEGRATION_EXPLANATION": "连接你的账户并查看由推特带来的转化和分析",
                    "TWITTER_TERMS_AND_CONDITIONS_HEADER": "Twitter移动归因跟踪转化条款"
                },
                "PLACEHOLDER": {
                    "ADNET": "检索媒体伙伴",
                    "CAMPAIGN_NAME": "输入名称以区分跟踪链接",
                    "DESTINATION_2": "选择落地页URL",
                    "DESTINATION_URL": "选择落地页",
                    "SITE": "选择应用版本"
                },
                "PLEASE_CONFIG_THIS_SOURCE": "请先配置该媒体伙伴",
                "SITE": "应用版本",
                "SOURCE_CONFIG": "配置媒体伙伴",
                "SOURCE_LABEL": "渠道",
                "VIEW_THROUGH_LINK": "展示归因监测连接"
            },
            "GOALS": {
                "NO_GOALS_MSG": "尚无已创建的目标，请点击<a class=\"new-goal-link\" href=\"#/goals/new\" class=\"text-success create-goal\">这里</a> 添加一个目标。",
                "NO_GOALS_TEXT": "尚无已创建的目标",
                "PREAMBLE": "了解更多内容，请点击 <a class=\"link-underline\" target=\"_blank\" href=\"https://support.singular.net/hc/zh-cn/articles/206975446-Goal-Management-FAQ\">帮助中心</a>"
            },
            "HOMEPAGE": {
                "MENU_ITEMS": {
                    "ADVANCED_SETUP_CATEGORY_LABEL": "高级设置",
                    "APPS_BUTTON": "开始",
                    "APPS_CONTENT_TITLE": "如何配置应用",
                    "APPS_LABEL": "添加应用",
                    "BASIC_SET_UP_CATEGORY_LABEL": "基本设置",
                    "BASIC_SET_UP_INTRO_BUTTON": "开始",
                    "BASIC_SET_UP_INTRO_CONTENT_TITLE": "欢迎使用Singular",
                    "BASIC_SET_UP_INTRO_LABEL": "开始",
                    "BI_POSTBACKS_BUTTON": "进行BI回传配置",
                    "BI_POSTBACKS_CONTENT_TITLE": "如何为内部BI配置回传",
                    "BI_POSTBACKS_LABEL": "配置BI回传",
                    "BOOKMARKS_BUTTON": "开始",
                    "BOOKMARKS_CONTENT_TITLE": "如何使用书签来保存报告",
                    "BOOKMARKS_LABEL": "使用书签来保存报告",
                    "COHORTED_EVENTS_BUTTON": "开始",
                    "COHORTED_EVENTS_CONTENT_TITLE": "如何创建自定义事件",
                    "COHORTED_EVENTS_LABEL": "创建自定义事件",
                    "CUSTOM_DIMENSIONS_BUTTON": "开始",
                    "CUSTOM_DIMENSIONS_CONTENT_TITLE": "如何通过添加自定义维度来定制化报告",
                    "CUSTOM_DIMENSIONS_LABEL": "添加自定义维度",
                    "DATA_CONNECTORS_BUTTON": "添加渠道",
                    "DATA_CONNECTORS_CONTENT_TITLE": "配置渠道",
                    "DATA_CONNECTORS_LABEL": "添加渠道",
                    "EXPORT_LOGS_BUTTON": "开始",
                    "EXPORT_LOGS_CONTENT_TITLE": "如何下载原始数据",
                    "EXPORT_LOGS_LABEL": "分析用户级别的原始数据",
                    "GET_STARTED_ADWORDS_BUTTON": "开始",
                    "GET_STARTED_ADWORDS_CONTENT_TITLE": "如何设置AdWords",
                    "GET_STARTED_ADWORDS_LABEL": "设置Adwords",
                    "GET_STARTED_FACEBOOK_BUTTON": "开始",
                    "GET_STARTED_FACEBOOK_CONTENT_TITLE": "如何设置Facebook",
                    "GET_STARTED_FACEBOOK_LABEL": "设置Facebook",
                    "INVITE_USERS_BUTTON": "开始",
                    "INVITE_USERS_CONTENT_TITLE": "为团队成员创建后台账户",
                    "INVITE_USERS_LABEL": "添加后台账户",
                    "MANAGE_LINKS_BUTTON": "开始创建",
                    "MANAGE_LINKS_CONTENT_TITLE": "如何生成和管理跟踪链接",
                    "MANAGE_LINKS_LABEL": "创建跟踪链接",
                    "PARTNER_CONFIGURATION_BUTTON": "开始设置",
                    "PARTNER_CONFIGURATION_CONTENT_TITLE": "如何针对一般媒体伙伴进行归因设置",
                    "PARTNER_CONFIGURATION_LABEL": "设置媒体伙伴",
                    "REPORTING_API_BUTTON": "查看API文档",
                    "REPORTING_API_CONTENT_TITLE": "获取API密钥",
                    "REPORTING_API_LABEL": "配置数据报告API",
                    "REPORTING_INTEGRATIONS_CATEGORY_LABEL": "配置数据报告API和BI回传",
                    "REPORTING_INTEGRATIONS_INTRO_BUTTON": "开始进行",
                    "REPORTING_INTEGRATIONS_INTRO_CONTENT_TITLE": "如何以程序化的形式获取数据报告",
                    "REPORTING_INTEGRATIONS_INTRO_LABEL": "介绍",
                    "RUN_REPORT_BUTTON": "开始运行",
                    "RUN_REPORT_LABEL": "运行一个基本报告",
                    "RUN_ROI_REPORT_BUTTON": "开始运行",
                    "RUN_ROI_REPORT_CONTENT_TITLE": "分析",
                    "RUN_ROI_REPORT_LABEL": "运行一个ROI报告",
                    "SDK_CONSOLE_ADVANCED_EVENTS_BUTTON": "进行一般应用内事件测试",
                    "SDK_CONSOLE_ADVANCED_EVENTS_CONTENT_TITLE": "如何测试一般应用内事件",
                    "SDK_CONSOLE_ADVANCED_EVENTS_LABEL": "测试一般应用内事件",
                    "SDK_CONSOLE_BASIC_EVENTS_BUTTON": "进行安装测试",
                    "SDK_CONSOLE_BASIC_EVENTS_CONTENT_TITLE": "如何进行安装测试",
                    "SDK_CONSOLE_BASIC_EVENTS_LABEL": "测试安装",
                    "SDK_CONSOLE_REVENUE_EVENTS_BUTTON": "进行购买事件测试",
                    "SDK_CONSOLE_REVENUE_EVENTS_CONTENT_TITLE": "如何测试够购买事件",
                    "SDK_CONSOLE_REVENUE_EVENTS_LABEL": "测试购买事件",
                    "SDK_CONSOLE_TESTING_BUTTON": "添加测试设备",
                    "SDK_CONSOLE_TESTING_CONTENT_TITLE": "如何进行SDK接入测试",
                    "SDK_CONSOLE_TESTING_LABEL": "在SDK Console里进行接入测试",
                    "SDK_INTEGRATION_CATEGORY_LABEL": "接入Singular SDK",
                    "SDK_INTEGRATION_INTRO_BUTTON": "开始配置",
                    "SDK_INTEGRATION_INTRO_CONTENT_TITLE": "关于接入Singular SDK",
                    "SDK_INTEGRATION_INTRO_LABEL": "着手接入SDK",
                    "SDK_KEYS_AND_DOCUMENTATION_BUTTON": "查看SDK接入文档",
                    "SDK_KEYS_AND_DOCUMENTATION_CONTENT_TITLE": "如何获取SDK密钥和接入文档",
                    "SDK_KEYS_AND_DOCUMENTATION_LABEL": "获取SDK密钥和接入文档",
                    "SET_UP_CAMPAIGNS_CATEGORY_LABEL": "跟踪广告投放",
                    "SET_UP_CAMPAIGNS_INTRO_BUTTON": "开始",
                    "SET_UP_CAMPAIGNS_INTRO_CONTENT_TITLE": "在开始投放广告之前",
                    "SET_UP_CAMPAIGNS_INTRO_LABEL": "介绍",
                    "VIEW_DATA_CATEGORY_LABEL": "数据分析"
                }
            },
            "MANAGE_LINKS": {
                "ANDROID_REDIRECT_DESTINATIONS_LABEL": "配置安卓跳转落地页",
                "APP_SEARCH_PLACEHOLDER": "输入应用名称以进行检索",
                "ATTRIBUTION_SETTINGS_GROUP_LABEL": "归因设置",
                "ATTRIBUTION_SETTINGS_LABEL": "了解归因逻辑以及归因窗口，请点击<a class=\"link-underline\" href='https://support.singular.net/hc/zh-cn/articles/115000526963-Introduction-to-Singular-Attribution' target='_blank'>帮助中心</a>",
                "AUTO_COMPLETE_PLACEHOLDER": "输入内容或者从列表里选择",
                "AVAILABLE_LINKS": "可用链接",
                "CREATE_LINK_BUTTON": "创建链接",
                "CT_FINGERPRINT_WINDOW_LABEL": "点击到安装归因窗口（模糊匹配）",
                "CT_WINDOW_LABEL": "点击到安装归因窗口（设备识别码）",
                "CUSTOM_SOURCE_NAME_LABEL": "指定自定义渠道名称",
                "DDL_PLACEHOLDER": "不配置应用内落地页的话，默认跳转到应用首页",
                "DEEPLINK_LABEL": "配置深度链接：针对已安装用户，请选择应用打开时需要跳转的应用页面",
                "DEFAULT_TOOLTIP": "设置为默认域名",
                "DEFERRED_DEEPLINK_LABEL": "配置延迟深度链接：针对用户安装后首次打开应用的情况，请选择需要跳转的应用页面",
                "DETERMINISTIC_CLICK_WINDOW_TOOLTIP": "当广告渠道通过链接提供设备识别码（应用内广告通常支持设别识别码，而移动网页广告则相反），或者在谷歌referrer可用的情况下，系统才会采用此种归因方式。<br/>点击<a href='https://support.singular.net/hc/zh-cn/articles/115000526963#click_install_id' target='_blank' class=\"link-underline\">帮助中心 - 归因方式</a> 了解更多相关内容。",
                "DETERMINISTIC_VIEW_WINDOW_TOOLTIP": "当广告渠道通过链接提供设备识别码（应用内广告通常支持设别识别码，而移动网页广告则相反），系统才会采用此种归因方式。<br/>点击<a href='https://support.singular.net/hc/zh-cn/articles/115000526963#click_install_id' target='_blank' class=\"link-underline\">帮助中心 - 归因方式</a> 了解更多相关内容。",
                "FALLBACK_DESTINATIONS_LABEL": "为其它平台设置回退URL",
                "FALLBACK_FIELD_LABEL": "针对用户在其它平台点击广告的情况（如桌面端网页)，请选择回退URL",
                "FALLBACK_PLACEHOLDER": "输入回退URL",
                "FALLBACK_TOOLTIP": "当跟踪链接不支持用户设备所搭载的平台（如桌面端网页），或者没有为该链接配置任何落地页时，默认跳转到回退URL。",
                "GENERATE_BUTTON": "生成链接",
                "GROUP_TITLE_CUSTOM": "自定义链接",
                "GROUP_TITLE_PARTNER": "媒体伙伴链接",
                "IOS_REDIRECT_DESTINATIONS_LABEL": "配置iOS跳转落地页",
                "LAST_UPDATE": "最后更新时间 ${lastModified}",
                "LEGACY_TOGGLE_TOOLTIP": "在新版链接格式发布前由旧有格式生成的链接会被系统标示为旧格式链接，启用下面的按键以查看旧有格式链接。",
                "LINK_NAME_TOOLTIP": "为了区分各个链接，请为该链接指定一个特定的名称。在生成报告的时候，可以通过 “Tracker Name”维度查看该链接名称。",
                "LINK_PARAMETERS_LABEL": "为链接配置参数以向Singular传递更多信息，您也可以添加自定义参数。<a class=\"link-underline\" href='https://support.singular.net/hc/zh-cn/articles/360018879491' target='_blank'>点击了解更多</a>。",
                "LINK_ROW_ITEM_CREATED_AT": "创建时间 ${createdDisplay}",
                "LINK_ROW_ITEM_UPDATED_AT": "最后更新时间 ${modifiedDisplay}",
                "LINK_SETTINGS_GROUP_LABEL": "配置链接和跳转",
                "LINK_SETTINGS_LABEL": "为该链接配置跳转规则，<a class=\"link-underline\" href='https://support.singular.net/hc/zh-cn/articles/360030934212-Singular-Links-FAQ#redirects' target='_blank'>点击了解更多</a>",
                "LINK_TYPE_LABEL": "选择链接类型",
                "LINK_TYPE_TOOLTIP": "如果将要投放广告的渠道是与Singular建立了对接的媒体伙伴，请选择”媒体伙伴“。<br/>如果要在邮件、短信等其它类型的渠道投放广告，请选择”自定义链接“。",
                "MANAGE_SUBDOMAINS": "管理链接域名",
                "OLD_LINKS_TOGGLE_LABEL": "显示旧格式链接 (${count})",
                "OVERRIDE_ATTRIBUTION_WINDOW_CUSTOM_LABEL": "为该链接单独配置归因窗口",
                "REDIRECT_LABEL": "如过该用户未安装应用，则跳转到：",
                "RE_ENGAGEMENT_LABEL": "开启再营销广告追踪",
                "RE_WINDOW_LABEL": "点击到再营销归因窗口（设备识别码）",
                "SHELF_TITLE": "为移动应用归因生成一个跟踪链接。Singular通过跟踪链接获取用于归因的信息并引导用户从广告链接跳转到商店下载页或应用内部内容。",
                "SITE_DEEPLINK_PLACEHOLDER": "不配置应用内落地页的话，会按照未安装应用的情况处理跳转",
                "SITE_LABEL": "应用版本",
                "SOURCE_NAME_LABEL": "选择媒体伙伴",
                "SUBDOMAIN_SHELF_ADD": "已添加的域名 (${subDomainsCount}/${limit}):",
                "SUBDOMAIN_SHELF_CREATE": "生成域名",
                "SUBDOMAIN_SHELF_HEADER": "管理链接域名",
                "SUBDOMAIN_SHELF_INFO": "Singular系统默认使用\"sng.link\"作为链接域名，但是可以自定义子域名。",
                "SUBDOMAIN_SHELF_SUB_TITLE": "添加新域名",
                "SUBDOMAIN_SHELF_TITLE": "配置跟踪链接所使用的域名，点击<a class=\"link-underline\" href=\"https://support.singular.net/hc/zh-cn/articles/360030934212-Singular-Links-FAQ#what_is_a_link_sub_domain\" target=\"_blank\">帮助中心</a>了解更多关于域名管理和相关要求的内容。",
                "SUB_DOMAIN_LABEL": "链接子域名",
                "TRACKER_LINK_NAME_LABEL": "指定链接名称",
                "VT_FINGERPRINT_WINDOW_LABEL": "展示到安装归因窗口（模糊匹配）",
                "VT_WINDOW_LABEL": "展示到安装归因窗口（设备识别码）"
            },
            "NEW_ALERT": {
                "ALERT_ME_WHEN": "为该提醒设置指标条件",
                "ALERT_STATUS": "开启状态",
                "CHECK_ALERT_ON_EACH": "为该提醒设置维度条件",
                "PLACEHOLDERS": {
                    "ALERT_TITLE": "为该提醒指定名称",
                    "EMAIL": "邮箱地址",
                    "FILTER_VALUES": "请指定（可选）",
                    "METRIC": "数据指标",
                    "NOTES": "为提醒邮件添加内容"
                },
                "PREAMBLE": "设定触发提醒的条件 <a href=\"https://singular.zendesk.com/hc/en-us/articles/207429303-How-to-Use-Alerts-Part-2-Configuration\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">点击了解更多信息</a>",
                "SEND_EMAIL_TO": "输入接收提醒的邮箱地址（可输入多个地址）"
            },
            "NEW_GOAL": {
                "BREAKDOWNS": {
                    "Ad Networks": "渠道",
                    "Apps": "应用",
                    "Country": "国家",
                    "Platforms": "平台"
                },
                "BREAKDOWNS_TITLE": "添加维度条件",
                "DURATION": "指定有效期间",
                "GOAL_NAME": "为该目标指定名称",
                "METRIC": "添加数据指标",
                "SUB_GOALS": "子目标",
                "TOTAL_BUDGET": "总预算"
            },
            "PARTNER_CONFIG": {
                "STATUS_INDICATION_INACTIVE": "闲置中",
                "STATUS_INDICATION_OK": "活动中"
            },
            "REPORTS": {
                "BOOKMARKS": {
                    "PUBLIC": "和其他用户分享书签",
                    "REMOVE": "删除该书签",
                    "ROLLING_PERIOD": "滚动时间",
                    "SAVE": "保存",
                    "STATIC_PERIOD": "指定日期",
                    "TIME_PERIOD": "期间选项",
                    "TITLE": "指定书签名称"
                },
                "UNIFIED_BANNER": {
                    "HEADER": "解锁 SKAN 和 iOS 洞察",
                    "SUB_HEADER": "统一指标结合 SKAN 和 第三方 MMP 数据，创建一个单一的、去重的，精确的 iOS 安装转化和收入视图。",
                },
                "CHART_METRIC_NO_DATA": "针对该指标没有可以显示的数据",
                "CHART_NO_DATA": "没有可以显示的数据",
                "COMPARE_WARNING": "注意：对比期间的时间长度不一致，请重新设置",
                "DATEPICKER_PERIOD_TITLE": "已选期间",
                "DATEPICKER_PREVIOUS_PERIOD_TITLE": "对比期间",
                "DIMENSION_DRILLDOWN_DISABLED_SELECTION": "要按照Publisher维度分解数据，在生成报表时至少要选择App和Source维度",
                "DIMENSION_DRILLDOWN_HEADER": "以该项目为基准，按照下列维度对数据分解",
                "DIMENSION_DRILLDOWN_ICON_TOOLTIP": "点击以分解数据",
                "GOAL_WARNING": "注意：该目标所设定的结束期间尚未发生，只能显示部分数据",
                "GOAL_WARNING_2": "注意：该目标的设定期间尚未发生，无可显示的数据",
                "METADATA_DIMENSION_SUB_TEXT": "点击查看目前所支持的<a href=\"https://support.singular.net/hc/zh-cn/articles/360032548672-Campaign-Properties-FAQ\" target='_blank'>广告渠道</a>",
                "ADMON_DAU_METRICS_SUB_TEXT": "Available for <a href=\"https://support.singular.net/hc/zh-cn/articles/360022067552-Ad-Monetization-Analytics-FAQ#User_Activity_Metrics_DAU_and_ARPDAU\" target='_blank'>selected dimensions</a>",
                "PERFORMANCE_WARNING": "<div>注意：生成country或者campaign维度报告需要较长时间</div><div>如果需要更快的生成报告，请缩短报告期间</div>",
                "PUBLISHER_PERFORMANCE_WARNING": "<div>注意：Publisher维度系涉及大量数据</div><div>因此运行报告前需要先限定App和Source<</div>",
                "ADMON_DAU_WARNING": "<div>DAU and ARPDAU are only available for the dimensions app, OS, and/or country.</div>",
                "SUBHEADER_FAQ": "了解更多关于如何生成报告的内容，请点击 <a href=\"https://support.singular.net/hc/zh-cn/articles/205046069-Reports-FAQ\" class=\"link-underline\" target=\"_blank\">帮助中心。</a>",
                "VALIDATION_ERROR_PERIOD_FOR_COHORT": "至少需要选择一个期间",
                "VALIDATION_ERROR_SELECT_GOAL": "选择一个目标",
                "VALIDATION_ERROR_SELECT_METRIC": "至少需要选择一个指标",
                "VALIDATION_ERROR_ALLOWED_DIMENSIONS": "DAU and ARPDAU are not available for the dimensions you selected. To run a report with DAU and/or ARPDAU, remove all dimensions except for app, OS, and country.",
            },
            "SDK_CONSOLE": {
                "ADD_DEVICE": "添加测试设备",
                "FORGET_DEVICE": "清除测试设备归因记录",
                "FORGET_DEVICE_CANCEL": "否，取消操作",
                "FORGET_DEVICE_CONFIRM": "是，确认清除"
            },
            "TEAM_MEMBERS": {
                "AUTO_ADD_FUTURE_ITEMS": {
                    "TITLE": "当出现新的 ${itemType} 时，自动获得授权",
                },
                "CHANGING_TO_ADMIN_WARNING": "如果更改授权类型为“管理员”，那么该用户将获得查看所有数据和使用所有功能的权限。",
                "EMAIL": "邮箱地址",
                "EXTERNAL_USER_WARNING": "请注意要授权的用户邮箱域名与该账户的企业域名不符，针对外部用户，建议您根据企业的数据安全准则授权",
                "FIRST_NAME": "名",
                "GROUP_NAME_ACTIVE": "已接受授权用户",
                "GROUP_NAME_INACTIVE_TEAM_USERS": "解除授权用户",
                "GROUP_NAME_PENDING_TEAM_USERS": "尚未接受授权用户",
                "INVITE": "授权新用户",
                "INVITE_FULL_MEMBER": "授权新用户",
                "LAST_NAME": "姓",
                "MANAGE_PERMISSIONS": "管理权限",
                "ME": "当前用户",
                "REINVITE_DISABLED_TOOLTIP": "24小时内只能重新发送一次邀请",
                "RESEND_INVITE_REACT": "重新发送邀请",
                "RE_INVITE_SENT": "授权邀请已经发送到 ${userName}",
                "ROLE_SELECTION_CREATE_USER_TITLE": "请选择授权类型",
                "ROLE_SELECTION_MANAGE_USER": "请为 ${userName} 选择授权类型",
                "SELECT_AT_LEAST_ONE_TOOLTIP": "请至少选择一个 ${itemType}",
                "SHELF_CREATE_NEW_USER": "创建新用户",
                "SHELF_MANAGE_USER_PERMISSIONS": "管理用户权限",
                "USER_DELETED": "${userName}'s 用户授权已被解除",
                "USER_TYPE_ADMIN": "管理员用户",
                "USER_TYPE_RESTRICTED": "受限用户",
                "USER_TYPE_STANDARD": "标准用户",
                "WIZARD_CHANGE_USER_TYPE": "更改授权类型",
                "WIZARD_SCREENS_ENABLE_EXPORT_LOGS": "要授权该用户使用‘下载原始数据’功能，该用户必须获得查看所有数据指标的权限。",
                "WIZARD_SCREEN_SELECTION_TITLE": "选择要授权的功能",
                "WIZARD_SUMMARY_APPS_TITLE": "授权管理的应用",
                "WIZARD_SUMMARY_DS_TITLE": "授权管理的渠道",
                "WIZARD_SUMMARY_METRICS_TITLE": "授权查看的数据指标",
                "WIZARD_SUMMARY_SCREENS_TITLE": "授权使用的功能",
                "WIZARD_SUMMARY_USER_DETAILS_EMAIL": "邮箱",
                "WIZARD_SUMMARY_USER_DETAILS_NAME": "用户名称",
                "WIZARD_SUMMARY_USER_DETAILS_TITLE": "用户信息",
                "WIZARD_SUMMARY_USER_TYPE": "授权类型"
            },
            "TWO_FACTOR_AUTH": {
                "P1": "双重认证<strong>尚未启用</strong>",
                "P1_ACTIVE": "双重认证<strong>已启用</strong>",
                "P2": "启用双重认证以提高您账户的安全性。启用后，你需要在移动设备上安装的认证应用内获取验证码，并结合账户密码才可以完成登陆。",
                "P3": "<strong>注意：</strong>开启双重认证后，您将在所有已登陆Singular账户的设备上登出。"
            },
            "TWO_FACTOR_AUTH_CONFIG": {
                "PREAMBLE": "配置双重认证后，您需要在指定的认证应用内输入指令才可以登陆Singular后台。",
                "STEP_1": {
                    "DESCRIPTION": "获取认证应用",
                    "INSTRUCTIONS": "请选择一个认证应用并将其安装在您的移动设备上，<a href=\"https://m.google.com/authenticator\" target=\"_blank\">Google Authenticator</a>, <a href=\"http://guide.duosecurity.com/\" target=\"_blank\">Duo Mobile</a>, <a href=\"https://www.authy.com/\" target=\"_blank\">Authy</a>, <a href=\"https://www.windowsphone.com/en-us/store/app/authenticator/e7994dbc-2336-4950-91ba-ca22d653759b\" target=\"_blank\">Windows Phone Authenticator</a>",
                    "TITLE": "第一步"
                },
                "STEP_2": {
                    "DESCRIPTION": "扫描二维码",
                    "HELP": "用应用内的手动输入代替扫描或者应用所提供的限时密钥</p> <p><code>{{code}}</code></p> <p>随后应用会生成6位验证码",
                    "INSTRUCTIONS": "打开认证应用：<ul><li>点击 ”+“ 或者 ”添加账户“</li><li>用移动设备扫描左侧的二维码</li></ul>",
                    "TITLE": "第二步"
                },
                "STEP_3": {
                    "DESCRIPTION": "输入验证码",
                    "INSTRUCTIONS": "在下方输入认证应用内所生成的6位验证码",
                    "TITLE": "第三步"
                }
            },
            "VALIDATE_ACTION_MODAL": {
                "ACTION_NO": "否，我要撤回该操作",
                "ACTION_YES": "是，{{confirmText}}"
            },
            "PARTNER_CONFIGURATION": {
                "EMPTY_STATE_HEADER": "添加首个渠道",
                "EMPTY_STATE_SUB_HEADER": "合作伙伴配置定义将发送给合作伙伴的事件",
                "EMPTY_STATE_NEW_UAN_PLACEHOLDER": "搜索广告渠道合作伙伴",
                "EMPTY_STATE_DROPDOWN_HOVER": "添加为新合作伙伴",
                "CHOOSE_TOP_NETWORK": "或从选择常用的渠道合作伙伴",
                "ADD_PARTNER": "添加渠道合作伙伴",
                "ADD_APP_SITE": "添加应用",
                "EXPORT_ALL": "下载所有配置信息",
                "EXPORT_ALL_FAILURE_MESSAGE": "下载失败",
                "USER_CONFIGURATION": "用户配置",
                "ALL_USERS": "发送所有回传给 ${partnerName}，包括所有归因渠道",
                "ALL_USERS_EVENT": "发送至少一个事件的回传给 ${partnerName}，包括所有归因渠道",
                "ATTRIBUTED": "仅针对归因为 ${partnerName} 渠道的用户发送回传",
                "LIMITED_DATA_SHARING": "有限数据共享",
                "RESTRICTED": "受限",
                "NOT_RESTRICTED": "不受限",
                "DELETE_CONFIGURATION_MESSAGE": "您确定要永久删除此合作伙伴配置吗？",
                "MISSING_SITE": "此回传处于活动状态，但应用程序不可用。它已被删除或移至“测试应用程序”，您可以通过“应用程序”页面管理您的设置。e",
                "FILTER": "筛选基准",
                "FILTER_PLACEHOLDER": "检索",
                "TABLE_COLUMNS": {
                    "APP_SITE": "应用",
                    "CLICK_THROUGH_WINDOW": "点击归因窗口",
                    "POSTBACKS_TO_PARTNER": "向渠道合作伙伴发送回传",
                    "LAST_EDITED": "上一次编辑",
                    "PRIVACY": "隐私",
                },
                "ATTRIBUTED_TYPES": {
                    "ATTRIBUTED": "归因",
                    "ALL_USERS": "所有用户",
                },
                "POSTBACK_TYPES": {
                    "REVENUE": "收入",
                    "EVENTS": "${eventsCount} 事件",
                    "NO_EVENTS": "没有事件",
                    "INSTALL": "安装转化",
                    "REENGAGEMENT": "在营销转化",
                }
            },
            "ONBOARDING_GUIDE": {
                "PAGE_HEADER": "欢迎加入！",
                "PAGE_SUB_HEADER": "完成以下任务以开始使用：",
                "MENU_HEADERS": {
                    "BASIC_SET_UP_CATEGORY": "开始使用",
                    "SET_UP_CAMPAIGNS_CATEGORY": "开始投放广告活动",
                    "VIEW_DATA_CATEGORY": "分析您的数据",
                    "SKAN_CATEGORY": "开始投放 iOS 14 和 SKAdNetwork 广告活动",
                    "ADMON_CATEGORY": "开始进行广告变现",
                },
                "MENU_ITEMS": {
                    "BASIC_SET_UP_INTRO": "欢迎",
                    "SETUP_YOUR_APPS": "设置您的应用",
                    "APPS": "添加应用",
                    "SDK_INTEGRATION_SUBCATEGORY": "集成 Singular SDK",
                    "SETUP_YOUR_SOURCES": "设置数据来源",
                    "AUDIT_REPORT": "运行审核报告",
                    "VALIDATE_SETUP": "验证您的设置",
                    "PARTNER_CONFIGURATION_SUBCATEGORY": "设置归因",
                    "PARTNER_CONFIGURATION": "设置归因",
                    "DATA_CONNECTORS_SUBCATEGORY": "设置数据连接器",
                    "DATA_CONNECTORS": "添加数据连接器",
                    "MANAGE_LINKS": "构建追踪链接",
                    "CUSTOM_SOURCES_LINKS": "构建自定义链接",
                    "TEST_LINKS": "测试追踪链接",
                    "DEEP_LINKING": "构建深度链接广告活动",
                    "RUN_REPORT": "您的报告",
                    "VISUALIZE_CAMPAIGNS": "可视化广告活动表现",
                    "COHORTED_EVENTS": "添加您的事件",
                    "REPORTS": "了解不同类型的报告",
                    "REPORTS_AND_PIVOTS": "了解报告与数据透视表",
                    "RUN_ADDITIONAL_REPORT": "了解附加报告",
                    "EXPORT_DATA": "导出您的数据（ETL/API）",
                    "ETL": "数据导出指南",
                    "SKAN_INTRO": "Singular SKAdNetwork 方案简介",
                    "SKAN_FACEBOOK": "SKAN 与 Facebook",
                    "SKAN_ADWORDS": "SKAN 与 Google Ads",
                    "SKAN_CONVERSION_MODEL": "SKAN 转化模型",
                    "SKAN_PROBABILISTIC": "使用概率归因",
                    "SKAN_REPORTING": "运行 SKAdNetwork 报告",
                    "ADMON_INTRO": "设置广告变现",
                    "ADMON_ANALYZE": "分析广告变现",
                    "ADMON_SETUP_REVENUE": "设置广告收入事件",
                    "ADMON_EXPORT": "导出广告收入数据",
                    "SDK_INTEGRATION": "集成 Singular SDK",
                    "SDK_CONSOLE_TESTING": "测试 SDK 集成",
                    "WEB_SDK_INTEGRATION": "设置网页归因",
                    "SDK_CONFIGURATION": "规划您的对接流程",
                    "SDK_CONSOLE_BASIC_EVENTS": "添加您的事件",
                    "DEBUGGING_TOOLS": "调试工具：",
                    "ADVANCED_SETUP": "高级设置：",
                    "SET_UP_FACEBOOK": "设置 Meta Ads / Instagram",
                    "SET_UP_GOOGLE": "设置 Google Ads",
                    "SET_UP_APPLE_SEARCH_ADS": "设置 Apple Search Ads"
                },
                "CONTENT_TITLE": {
                    "BASIC_SET_UP_INTRO": "欢迎使用 Singular",
                    "APPS": "如何添加应用：",
                    "SDK_INTEGRATION": "集成 Singular SDK",
                    "SDK_CONSOLE_TESTING": "使用 SDK 控制台进行测试",
                    "SDK_CONSOLE_BASIC_EVENTS": "测试哪些事件",
                    "PARTNER_CONFIGURATION": "设置合作伙伴归因",
                    "GET_STARTED_FACEBOOK": "为 Facebook 设置合作伙伴归因",
                    "GET_STARTED_ADWORDS": "为 Google Ads 设置合作伙伴归因",
                    "DATA_CONNECTORS": "为数据来源添加数据连接器",
                    "SET_UP_FACEBOOK": "为 Facebook 设置数据连接器",
                    "SET_UP_GOOGLE": "为 Google Ads 设置数据连接器",
                    "VALIDATE_SETUP": "运行设置和 SDK 审核报告",
                    "MANAGE_LINKS": "构建并管理您的追踪链接",
                    "CUSTOM_SOURCES_LINKS": "使用自定义渠道开展广告活动",
                    "TEST_LINKS": "测试追踪链接",
                    "DEEP_LINKING": "使用深度链接运行广告活动",
                    "RUN_REPORT": "运行广告活动报告",
                    "VISUALIZE_CAMPAIGNS": "可视化广告活动表现",
                    "COHORTED_EVENTS": "添加您的事件",
                    "REPORTS_AND_PIVOTS": "了解报告与数据透视表",
                    "ADVANCED_REPORTING": "高级报告设置",
                    "RUN_ADDITIONAL_REPORT": "了解附加报告",
                    "EXPORT_DATA": "探索访问数据的其他方式",
                    "REPORTING_API": "Singular API 指南",
                    "BI_POSTBACKS": "BI 回传指南",
                    "ETL": "数据导出目的地指南",
                    "SKAN_INTRO": "Singular SKAdNetwork 解决方案简介",
                    "SKAN_FACEBOOK": "SKAN 与 Facebook",
                    "SKAN_ADWORDS": "SKAN 与 Google Ads",
                    "SKAN_CONVERSION_MODEL": "设置转化模型",
                    "SKAN_PROBABILISTIC": "使用概率归因",
                    "SKAN_REPORTING": "运行 SKAdNetwork 报告",
                    "ADMON_INTRO": "开始广告变现",
                    "ADMON_ANALYZE": "如何分析广告变现",
                    "ADMON_SETUP_REVENUE": "开始计算广告收入 ROI",
                    "ADMON_EXPORT": "导出广告收入数据"
                },
                "CONTENT": {
                    "BASIC_SET_UP_INTRO": "欢迎使用 Singular！准备好开始了吗？我们的指南将帮助您完成设置，开始投放广告活动。您还将了解 Singular 提供的各种分析产品。<br /><br />" +
                        "想了解关于 iOS 和 SKAdNetwork 的入门信息？<br />请直接跳转至下方指南。<br /><br />" +
                        "如果您在此找不到所需内容，您可以随时访问我们的 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn'>帮助中心</a>。",
                    "APPS": "欢迎使用 Singular！让我们从添加您的应用开始，这样 Singular 就可以开始接收数据了。<br/>" +
                        "如果您在 Android 和 iOS 上有同一个应用，请将它们作为同一个应用下的两个“应用站点”添加。下面是详细的分步骤说明：<br /><br />" +
                        "操作说明：" +
                        "<ol>" +
                        "<li>进入 <strong>设置 > 应用</strong>。</li>" +
                        "<li>如果您的应用未自动添加，请点击 <strong>添加新应用</strong>。</li>" +
                        "<li>在新创建的应用下，输入应用名称，并确认拼写正确。</li>" +
                        "<li>选择您发布或将要发布应用的平台（如 iOS、Android 等）。</li>" +
                        "<li>如果您的应用已上线，请将应用商店的链接粘贴到 <strong>应用商店 URL</strong> 字段中，然后点击 <strong>保存</strong>。</li>" +
                        "<li>（可选）如果您的 iOS 应用已提交审核，您也可以在 <strong>站点公开 ID</strong> 字段中填写 appstore_id。</li>" +
                        "<li>如果应用尚未上线，请选择 <strong>Bundle ID</strong> 选项，将应用的包名粘贴到 <strong>Bundle ID</strong> 字段，然后点击 <strong>保存</strong>。</li>" +
                        "</ol><br />" +
                        "<strong>有疑问？</strong>请查看 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360025661232-Apps-App-Configuration-FAQ'>应用设置常见问题</a>",
                    "SDK_KEYS_AND_DOCUMENTATION": "使用 <a href='#/react/sdk_integration'><strong>SDK 规划工具</strong></a>，" +
                        "为您提供逐步集成 SDK 的指导说明",
                    "SDK_CONSOLE_TESTING": "使用 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/testing-console'>开发者工具 > 测试控制台</a> 测试您的 SDK 集成。" +
                        "该控制台会显示您的应用通过 SDK 发送给Singular的会话、应用内事件及其他数据。<br/><br/>" +
                        "开始前请务必阅读 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115000497903-Using-the-SDK-Console'>测试控制台指南</a>。<br/><br/>" +
                        "<strong>开始前请注意：</strong>" +
                        "<ul style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li>在安装应用或开始测试前，先将您的设备添加到测试控制台。</li>" +
                        "<li>找不到测试设备 ID？Singular 提供了 <strong>Device Assist</strong> 应用。点击下载：" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://itunes.apple.com/us/app/singular-device-assist/id1441750662?mt=8'>iOS</a> 或 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://play.google.com/store/apps/details?id=net.singular.deviceassist2'>Android</a>。</li>" +
                        "<li>参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115000497903-Using-the-SDK-Console'>测试控制台指南</a></li>" +
                        "</ul><br />" +
                        "将测试设备添加到控制台后，即可开始测试 SDK 集成。请检查以下内容：" +
                        "<ol>" +
                        "<li><strong>安装事件：</strong>Singular 在检测到来自新设备的会话时会识别为安装。<br />" +
                        "检查 SDK 是否正确发送会话的方法：" +
                        "<ul>" +
                        "<li>iOS：查看 SDK 启动会话事件中的 ‘attribution_token’ 参数是否包含 Apple 的 token 值。</li>" +
                        "<li>Android：检查初始会话事件后是否收到 \"__installReferrer\"。</li>" +
                        "<li>参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360002675072-Testing-Basic-Integration-Functionality'>如何测试 Singular SDK 集成</a></li>" +
                        "</ul><br /></li>" +
                        "<li><strong>收入事件：</strong>收入事件在测试控制台中以 \"is_revenue\" 显示。<br />" +
                        "<ul>" +
                        "<li>我们建议传递购买对象，以便 Singular 验证交易收据。只有有效收入才会在报表中反映。无效收入可在导出日志页面查看。</li>" +
                        "<li>参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360002675072--UPDATED-How-to-Test-Your-Singular-SDK-Integration#Test_Events'>测试事件</a> 与 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360002675072-Testing-Basic-Integration-Functionality#Test_Revenue'>测试收入</a></li>" +
                        "<li>参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href=''>应用内购买验证常见问题</a></li>" +
                        "</ul><br /></li>" +
                        "<li><strong>自定义用户 ID：</strong>为集成添加用户标识特别有助于跨设备跟踪用户，尤其是在用户屏蔽 Apple/Google 广告 ID 时。测试时请确认所有事件参数中包含“自定义用户 ID”。</li>" +
                        "</ol>",
                    "WEB_SDK_INTEGRATION": {
                        "INTEGRATION_STEPS": "<strong>开始使用 Web 跟踪：</strong></br>" +
                            "<ol>" +
                            "<li>" +
                            "<strong>将 Web SDK 集成到您的网站</strong>：只需在网站 HTML 中添加几行代码，即可开始跟踪用户行为和转化。" +
                            "您可以选择使用<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360039991491-Singular-Website-SDK-Native-Integration'>原生方式</a> " +
                            "或 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360037640472-Singular-Website-SDK-Google-Tag-Manager-Integration'>Google Tag Manager</a>。" +
                            "</li>" +
                            "<li>" +
                            "<strong>测试您的集成</strong>：确认 Web SDK 安装正确并能成功发送事件。" +
                            "在已集成 Singular SDK 的网页中加载页面，使用浏览器开发者工具检查网络请求是否包含 “PAGE_VISIT” 事件，且状态码为 200。" +
                            "</li>" +
                            "<li>" +
                            "<strong>配置广告跟踪链接</strong>：这些链接将引导用户访问您的网站，并让 SDK 捕获用户行为数据。" +
                            "点击<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360041317471'>此处</a>了解更多关于 Web 跟踪链接的信息。" +
                            "</li>" +
                            "</ol>",
                        "FAQ": {
                            "TITLE": "常见问题解答：",
                            "QUESTION_1": "我是否仍需要在“应用”页面添加一个应用？",
                            "ANSWER_1": "您必须在“应用”页面添加 Web 域名。",
                            "QUESTION_2": "在报表中“安装量”显示的是什么？",
                            "ANSWER_2": "Singular 默认将 Web 会话视为转化事件。若需自定义此设置，请联系您的解决方案工程师。",
                            "QUESTION_3": "Web SDK 能否跨域或跨子域跟踪用户行为？",
                            "ANSWER_3": "可以，您可以使用跨子域跟踪方式，例如通过 Cookie 自动保存或手动持久化实现。",
                        },
                        "LEARN_MORE": "<strong>此外，欢迎联系我们以了解更多内容：</strong></br>" +
                            "<ol>" +
                            "<li>" +
                            "<strong>Web 到 App 归因</strong> - Singular 支持追踪从 Web 到 App 的安装转化。要启用此功能，请在 Singular SDK 实现中加入相关代码，并联系解决方案工程师生成跟踪链接（该功能默认未开启）。" +
                            "了解详情 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360042283811-Website-to-App-Attribution-Forwarding-for-Mobile-Web'>请点击这里</a>。" +
                            "</li>" +
                            "<li>" +
                            "<strong>跨设备归因</strong> - 通过广告主上报的用户 ID 将多个设备和操作关联到同一用户，实现跨设备归因。" +
                            "此方法需要用户登录以确保跨平台跟踪的准确性。" +
                            "了解详情 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360040888232-Introduction-to-Singular-s-Cross-Device-Attribution'>请点击这里</a>。" +
                            "</li>" +
                            "<li>" +
                            "<strong>转化 API 集成</strong> - 通过服务器到服务器的方式，直接将转化数据发送至广告平台，实现更准确的广告活动归因。" +
                            "查看已集成的合作平台 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/categories/201687706-Attribution-and-Singular-Links#Conversion API Integrations'>请点击这里</a>。" +
                            "</li>" +
                            "</ol>"
                    },
                    "SDK_CONSOLE_BASIC_EVENTS": "如果您已经通过 SDK 成功上报事件，您可以在 <strong>报告与洞察 > 导出日志</strong> 中查看每个事件的详细信息<br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>激活（Installs）:</strong> 当 Singular 从新设备收到 <strong>session</strong> 时，会将其识别为一次激活。检查 SDK 是否正确发送 session：" +
                        "<ul style=\"text-align: left;padding: 10px 0 10px 20px\">" +
                        "<li><strong>iOS：</strong> 在 SDK 启动 session 时，检查是否包含 Apple token 值（位于 'attribution_token' 参数）。</li>" +
                        "<li><strong>Android：</strong> 初次 session 事件后，检查是否收到 \"__installReferrer\"。</li>" +
                        "<li>了解更多，请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360002675072-Testing-Basic-Integration-Functionality'>基础集成测试指南</a></li>" +
                        "</ul></li>" +
                        "<li><strong>收入事件：</strong> 如文档所述，可以用不同方式向 Singular 上报收入事件。无论使用哪种方法，该事件应在 SDK 控制台中显示为 \"is_revenue\"。详情请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360039567171-Testing-Events-and-Revenue'>测试事件与收入</a></li>" +
                        "<ul style=\"text-align: left;padding: 10px 0 10px 20px\">" +
                        "<li>如 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/categories/360002441132'>开发者文档</a> 所述，我们建议传入 purchase 对象，以便 Singular 验证交易凭证。仅验证通过的收入才会在报表中展示。</li>" +
                        "<li><strong>关于凭证验证有疑问？</strong> 请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href=''>应用内购买验证常见问题</a>。</li>" +
                        "</ul>" +
                        "<li><strong>自定义用户 ID：</strong> 在集成中添加用户身份识别，尤其有助于跨设备追踪用户，或当用户阻止使用 Apple/Google 广告标识符时使用。测试时，请确保所有事件中都包含自定义用户 ID 参数。</li>" +
                        "</ol>",
                    "PARTNER_CONFIGURATION": "Singular 报告两类数据：一类是从广告网络拉取的数据，另一类是由 Singular 的归因服务产生的数据。您在集成 SDK 时已经配置了归因服务。" +
                        "接下来我们将为每个广告合作伙伴设置归因设置，以便 Singular 能将数据反馈给他们。设置路径为：" +
                        "<strong>归因设置 > 配置渠道</strong><br/>" +
                        "对于 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://www.singular.net/glossary/self-attributing-network/#:~:text=How%20Singular%20works%20with%20self,%2C%20Snapchat%2C%20and%20Yahoo%20Gemini.'>自归因网络</a>，此步骤为强制要求。请参考导航栏中 Facebook 和 Google Adwords 的章节。<br /><br />" +
                        "<strong>操作步骤：</strong>" +
                        "<ol><li>进入 <strong>归因设置 > 配置渠道</strong> 并选择一个合作伙伴。</li>" +
                        "<li>您需要按应用 site 配置归因设置，例如：<ol>" +
                        "<li>您想发送哪些事件给合作伙伴？<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360036736891-Defining-In-App-Events'>查看选择事件的建议</a></li>" +
                        "<li>是否在运行再营销（re-engagement）？</li>" +
                        "<li>是否只按展示或点击归因？</li>" +
                        "</ol></li></ol>" +
                        "需要更多帮助？请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115000483946-Partner-Configuration'>合作伙伴配置指南</a><br/>" +
                        "如需特定合作伙伴说明，请查看 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/categories/201687706-Attribution-and-Singular-Links#Partner%20Integrations%20in%20Detail'>合作伙伴集成指南</a>。",
                    "GET_STARTED_FACEBOOK": "在 <strong>Partner Configuration</strong> 中设置 Facebook，以便 Singular 开始追踪激活与事件<br/><br/>" +
                        "对于 Facebook，这就是全部配置内容 - 无需另外创建追踪链接。<br/><br/>" +
                        "<strong>设置 Facebook 的步骤：</strong>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li>确保您已签署 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://www.facebook.com/ads/manage/advanced_mobile_measurement/app_based_tos'>Facebook 高级移动衡量协议</a>。否则 Singular 无法将点击级数据包含在导出日志或数据目的地中。</li>" +
                        "<li>从 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.facebook.com/apps'>Facebook 应用后台</a> 获取 App ID，并填写至 Singular 的 <strong>Partner Configuration</strong> 中。</li>" +
                        "<li>配置归因设置。您可以启用/禁用展示归因并调整归因窗口。<br/>" +
                        "请注意：<strong>修改默认设置可能导致 Singular 与 Facebook 仪表板中的数据不一致</strong>。</li>" +
                        "<li>启用事件 postback 到 Facebook。这有助于根据某个关键事件优化广告系列（<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.facebook.com/docs/app-ads/optimizing-your-app-ad'>了解更多</a>）。</li>" +
                        "<li>如果您要通过 Facebook 运行 SKAdNetwork 广告系列，请参考 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360055071772'>Facebook SKAdNetwork 集成指南</a>。</li>" +
                        "</ol><br/>" +
                        "<strong>仍有疑问？</strong> 请参考我们的 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115003252706-Facebook'>Facebook 设置指南</a> 和 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360038261212'>故障排查指南</a>。",
                    "GET_STARTED_ADWORDS": "在 <strong>Partner Configuration</strong> 中设置 Google Ads，以便 Singular 开始追踪激活与事件。</br></<br>这是配置 Google Ads 所需的全部内容 - 无需创建追踪链接。<br/><br/>" +
                        "<strong>设置 Google Ads 的步骤：</strong><br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>输入 Link ID：</strong> 在 Google Ads 账户中生成 Link ID（参考 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.google.com/google-ads/answer/7365001?hl=en'>Google 指南</a>）。然后进入 Singular 的 <strong>Partner Configuration</strong> 输入该 ID。</li>" +
                        "<li>配置常规归因设置。</li>" +
                        "<li><strong>导入事件：</strong> 要追踪转化与事件，请在 Google Ads 中设置转化操作。参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360052936331'>Google Ads 事件导入指南</a><br/>" +
                        "请注意：Singular 的事件不会立刻出现在 Google Ads 中，只有在配置完成后首次发生转化事件之后，事件才会出现在 Google Ads 中。</li>" +
                        "<li><strong>发送事件：</strong> 为了提升广告优化效果，允许 Singular 向 Google Ads 回传应用内事件。您可以将事件映射至相应的 Google 事件，也可以保留为 \"custom\"。</li>" +
                        "</ol><strong>仍有疑问？</strong> 请参考我们的 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115003252786-Google-Ads-AdWords-'>Google Ads 指南</a>。",
                    "DATA_CONNECTORS": "Singular 报告两类数据 - 从广告网络提取的数据，以及来自 Singular 归因服务的数据。在本步骤中，我们将为每个广告平台设置数据连接器，使 Singular 能够接收网络数据。" +
                        "请前往 <strong>数据集成 > 数据连接器</strong> 完成设置。<br/><br/>" +
                        "<strong>操作步骤：</strong><br/>" +
                        "<ol>" +
                        "<li>进入 <strong>数据集成 > 数据连接器</strong></li>" +
                        "<li>点击“新建数据连接器”，在搜索框中查找您的广告网络平台。</li>" +
                        "<li>在弹出的渠道配置面板中，输入所需信息（通常为 API 密钥和用户名）。面板中会引导您在合作方后台哪里可以找到这些信息。</li>" +
                        "<li>对于 Facebook 和 Google Adwords，您可能需要使用具备相应权限的 Facebook/Google 账号登录。</li>" +
                        "</ol><br/><br />" +
                        "需要帮助？请查看我们的 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360031000051'>数据连接器常见问题</a>。",
                    "SET_UP_FACEBOOK":
                        "<p>Meta Ads / Facebook 是自归因广告平台，无需创建跟踪链接。请按照以下步骤开始配置。</p>" +
                        "<ol>" +
                        "<li><strong>添加数据连接器</strong> - Singular 将通过 Facebook 报告 API 拉取花费和网络统计数据。</li>" +
                        "<li><strong>添加渠道配置</strong> - 从 <a href='https://developers.facebook.com/apps' target='_blank'><u>Facebook 开发者平台</u></a> 获取您的 Facebook App ID。</li>" +
                        "<ol style=\"list-style-type:lower-alpha\">" +
                        "<li>在此处，您还需要添加转化后事件（post-install events）发送给Facebook用于其优化广告活动。</li>" +
                        "<li>还可以设置归因参数，如点击归因窗口。请确保设置与 Facebook 后台保持一致。</li>" +
                        "</ol>" +
                        "<li><strong><a href='https://support.singular.net/hc/zh-cn/articles/360055071772-Facebook-Ads-SKAdNetwork-Integration#4_Import_Conversion_Model_in_Facebook_Event_Manager' target='_blank'><u>SKAN 广告系列</u></a></strong> - 您需要完成以下操作：</li>" +
                        "<ol style=\"list-style-type:lower-alpha\">" +
                        "<li>在 <a href='https://app.singular.net/#/react/skadnetwork' target='_blank'><u>Singular 中设置转化模型</u></a>。请确保 SKAN 模型中使用的事件也在渠道配置中进行配置。</li>" +
                        "<li>进入 <a href='https://www.facebook.com/events_manager' target='_blank'><u>Facebook 事件管理器</u></a> 的 SKAdNetwork 事件配置页面。</li>" +
                        "<li>选择“设置” > “设置事件”。</li>" +
                        "<li>选择“从合作伙伴应用导入”。在接下来的页面中，Facebook 将提示您输入 MMP URL。</li>" +
                        "<li>构建以下 URL，并将您的 App Store ID 填入 app_id 参数：</li>" +
                        "<code class='codeBlock'>http://api.singular.net/api/skadnetwork/conversion_info?org_type=partner&app_id=[your_app_id]</code>" +
                        "</ol>" +
                        "<li><strong><a href='https://support.singular.net/hc/zh-cn/articles/115003252706-Facebook-Meta-Ads-Attribution-Integration#iOS_Aggregated_Event_Measurement_FAQ' target='_blank'><u>AEM 广告系列</u></a></strong> - 无需额外操作。如需在 Tracker Installs 下查看 AEM 归因的安装，请在渠道配置中启用高级 AEM 功能。了解详情请查看 <a href='https://support.singular.net/hc/zh-cn/articles/115003252706-Facebook-Meta-Ads-Attribution-Integration#whatisaem' target='_blank'><u>帮助中心</u></a></li>" +
                        "<li><strong>Android 广告系列</strong> - 请确保在渠道配置中正确设置 meta referrer。了解更多信息 <a href='https://support.singular.net/hc/zh-cn/articles/115003252706#whatismetareferrer' target='_blank'><u>请点击这里</u></a></li>" +
                        "</ol>" +
                        "<li>需要帮助？请查看 <a href='https://support.singular.net/hc/zh-cn/articles/208690176-Facebook-Data-Connector#Add_the_Data_Connector'  target='_blank'><u>帮助文档</u></a></li>",
                    "SET_UP_GOOGLE": "<p>要在 Singular 中设置 AdWords，您需要添加一个数据连接器和一个合作伙伴配置。无需创建跟踪链接。</p>" +
                        "<strong><p>请勿跳过以下任何步骤，以确保最佳配置效果。</p></strong>" +
                        "添加合作伙伴配置的步骤：<br/>" +
                        "<ol>" +
                        "<li>创建您的 Google Ads 链接 ID。<a href='https://support.google.com/google-ads/answer/7365001?hl=zh-CN' target='_blank' title='https://support.google.com/google-ads/answer/7365001?hl=zh-CN'><u>(?)</u></a></li>" +
                        "<li>在 <strong>归因</strong> &gt; <strong>渠道配置</strong> 中，点击 <strong>添加合作伙伴</strong>，输入并选择 “AdWords (Google Ads)”。</li>" +
                        "<li>配置 Singular 以发送转化后事件。</li>" +
                        "<li>需要帮助？请参阅 <a href='https://support.singular.net/hc/zh-cn/articles/115003252786-Google-Ads-AdWords-Attribution-Integration#How_to_Setup_your_Partner_Configuration' target='_blank'><u>帮助文档</u></a>。</li>" +
                        "</ol>" +
                        "添加数据连接器的步骤：<br/>" +
                        "<ol>" +
                        "<li>从 Google Ads 账户中获取您的 MCC 客户 ID。</li>" +
                        "<li>在 <strong>设置</strong> &gt; <strong>数据连接器</strong> 中，点击 <strong>添加数据连接器</strong>，输入并选择 “AdWords (Google Ads)”。</li>" +
                        "<li>使用您的 Google 凭据登录。</li>" +
                        "<li>打开已添加的数据连接器，并在指定字段中粘贴您的 MCC 客户 ID。</li>" +
                        "<li>激活您希望从中提取数据的账户。</li>" +
                        "<li>配置需要从 Adwords 获取的转化事件。</li>" +
                        "<li>需要帮助？请参阅 <a href='https://support.singular.net/hc/zh-cn/articles/360036750251-Google-Ads-AdWords-Data-Connector' target='_blank'><u>帮助文档</u></a>。</li>" +
                        "</ol>",
                    "SET_UP_APPLE_SEARCH_ADS": `
                        <div>
                        <p>要开始使用 Apple Search Ads，您需要准备以下三项：</p>
                        <ol>
                            <li>
                            集成 Singular SDK
                            <ol style="list-style-type: lower-alpha;">
                                <li>
                                <p>
                                    <strong>请确保包含 AdServices 框架！</strong>
                                    如果您使用 S2S 集成，请参考以下链接使用
                                    <a
                                    href="https://support.singular.net/hc/zh-cn/articles/360037640812-Server-to-Server-S2S-Integration-Guide"
                                    title="https://support.singular.net/hc/zh-cn/articles/360037640812-Server-to-Server-S2S-Integration-Guide"
                                    >S2S 集成指南（适用于 Apple Search Ads）</a
                                    >进行更新。
                                </p>
                                </li>
                            </ol>
                            </li>
                            <li>
                            <p>
                                添加
                                <a
                                href="https://app.singular.net/#/react/data-sources?id=1530"
                                title="https://app.singular.net/#/react/data-sources?id=1530"
                                >
                                Apple Search Ads <strong>数据连接器</strong>
                                </a>
                            </p>
                            </li>
                            <li>
                            <p>
                                在
                                <a
                                href="https://app.singular.net/#/partner-config?source=97172"
                                title="https://app.singular.net/#/partner-config?source=97172"
                                >
                                <strong>合作伙伴配置</strong>
                                </a>中设置 Apple Search Ads。Apple 不会接收用户事件，因此您无需配置事件，但在保存相关 App 信息站点之前，将无法看到安装数据。
                            </p>
                            </li>
                        </ol>
                        <p>
                            从 iOS 14.3 开始，Apple Search Ads 活动通过基于
                            <a
                            href="https://developer.apple.com/documentation/adservices"
                            title="https://developer.apple.com/documentation/adservices"
                            >
                            AdServices 框架
                            </a> 的全新自归因集成进行测量。iAd 框架已被 Apple 弃用。
                        </p>
                        <p>
                            <strong>我可以在哪看到报告数据？</strong>
                            Apple Search Ads 数据与 SKAdNetwork 独立，因此相关数据只会出现在传统（非 SKAN）报告和用户级导出中。
                        </p>
                        <p>
                            <strong>需要帮助？</strong> 请参阅
                            <a href="https://support.singular.net/hc/zh-cn/articles/115003234483" target="_blank">
                            Apple Search Ads 归因集成指南
                            </a>。
                        </p>
                        </div>
                    `,
                    "CUSTOM_SOURCES_LINKS": "您可以为自定义来源创建跟踪链接，例如电子邮件营销或社交媒体推广。<br/>" +
                        "<ol>" +
                        "<li>按照<strong>构建跟踪链接</strong>指南中的步骤操作，但在第 5 步的<strong>链接类型</strong>中，选择“自定义来源”。</li>" +
                        "<li>在<strong>来源名称</strong>下，选择 \"Crosspromo\"、\"Email\"、\"SMS\"、\"Social\" 或 \"Custom\"。<br/>您选择的值将在报表的<strong>来源</strong>维度中显示。</li>" +
                        "</ol><br/>",
                    "EXPORT_DATA": "Singular 可将数据直接导出到您的数据仓库、存储服务或 BI 平台。然后您可以使用自己的工具对数据进行处理和分析。" +
                        "Singular 提供多种数据结构。您可以在<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360039511492'>汇总数据结构</a>" +
                        "或<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360048784092'>用户级数据结构</a>中查看详细信息。<br/><br/>" +
                        "创建并保存数据目的地后，不能切换数据结构。因为更改已有数据的数据库表结构可能会带来风险和复杂性。<br/><br/>" +
                        "如果需要更改数据结构，请创建一个新的数据目的地。您可以在创建新目的地前删除旧表，或者让新目的地将数据加载到一个名称不同的新表中。" +
                        "这样可以确保数据安全，并保证现有查询和工作负载正常运行。<br/><br/>" +
                        "需要更多帮助？请参阅<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360037917571-Singular-Data-Destinations-ETL-FAQ'>Singular 数据目的地常见问题</a>",
                    "MANAGE_LINKS": "Facebook、Google Ads 和 Apple Search Ads 等广告网络是“自归因”类型，也就是说，它们会自行决定哪个广告导致了用户安装或曝光。<br/><br/>" +
                        "如果您只使用这些自归因网络，可能不需要这一步。<br/><br/>" +
                        "对于其他广告网络，跟踪链接可以帮助 Singular 获取相同的信息。同时，它也可用于自定义来源，如电子邮件或短信推广。<br/><br/>" +
                        "您可以在 Singular 中创建并自定义这些链接，例如：\"gamesco.sng.link\"，其中 <i>GamesCo</i> 是您的公司名。链接可包含参数，例如用户设备平台或广告创意素材，以增强报告的洞察力。<br/><br/>" +
                        "<strong>操作步骤：</strong>" +
                        "<ol>" +
                        "<li>确保您已按第6步设置好广告网络合作伙伴。</li>" +
                        "<li>进入<strong>归因设置 > 管理链接</strong>。</li>" +
                        "<li>点击<strong>管理链接域名</strong>并创建一个新的子域名。</li>" +
                        "<li>点击您的应用并选择<strong>创建链接</strong>。</li>" +
                        "<li>在<strong>链接类型</strong>中选择 \"合作伙伴\"。</li>" +
                        "<li>在<strong>来源名称</strong>中选择网络，在<strong>跟踪链接名称</strong>中命名您的链接。</li>" +
                        "<li>在链接设置与重定向部分，选择您的<strong>链接子域名</strong>。</li>" +
                        "<li>如果合作伙伴支持 Android 和 iOS 跟踪，您可以启用它们。选择适合您应用的站点，并提供重定向链接，通常是商店的地址。</li>" +
                        "<li>在<strong>其他平台跳转到</strong>中，填写备用链接地址，然后点击<strong>生成</strong>按钮创建您的跟踪链接。</li>" +
                        "</ol><br/>" +
                        "需要更多帮助？请参阅<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360030934212-Singular-Links-FAQ'>Singular 链接常见问题</a>",
                    "CUSTOM_SOURCES": "完善的营销策略通常包括电子邮件与短信营销、跨应用推广以及与社交媒体红人合作推广。<br/><br/>" +
                        "Singular 允许您通过为<strong>自定义来源</strong>设置跟踪链接来追踪这些活动。<br/><br/>" +
                        "自定义来源是指任何非预配置的合作广告网络渠道。<br/><br/>" +
                        "<strong>开始使用自定义来源：</strong>" +
                        "<ul>" +
                        "<li>为来源命名一个有代表性的名称，因为该名称将出现在报表中。</li>" +
                        "<li>您可以添加维度来细化报告。例如，如果在链接中添加了 campaign 参数，您将在报表中获得按活动分层的统计数据。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360018879491-Tracking-link-parameters-and-report-dimensions'>查看跟踪链接参数列表</a>。</li>" +
                        "<li>您还可以为自定义来源设置成本报告，通过添加 CPI 表格实现。请查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/206409915-CPI-Configuration-FAQ'>常见问题</a>。</li>" +
                        "</ul>",
                    "TEST_LINKS": "您已通过 <strong>管理链接</strong> 页面创建了一个跟踪链接。在将其用于广告活动之前，可以通过点击链接并在移动设备上安装应用进行测试，以查看 Singular 接收到哪些信息。<br/><br/>" +
                        "<strong>开始之前：</strong>" +
                        "<ul>" +
                        "<li>确保广告网络允许手动测试。某些网络会根据地理位置屏蔽点击。</li>" +
                        "<li>使用干净的设备（设备 ID 未被 Singular 跟踪过），或者根据说明重置设备 ID。</li>" +
                        "<li>检查 <strong>导出日志</strong>，确认点击和安装事件都已正确触发。</li>" +
                        "<li>或者，也可以使用 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360045803392-How-to-Verify-Device-Attribution#How_to_Verify_Attribution_Using_the_Attribution_Details_Endpoint'>Attribution Details API</a> 查看测试是否成功。</li>" +
                        "</ul><br/>" +
                        "<strong>有问题？</strong>请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360046951332-How-to-Test-a-Tracking-Link'>如何测试跟踪链接</a>。",
                    "DEEP_LINKING": "如果您希望将已有用户引导至应用内的特定页面，可以将跟踪链接配置为“深度链接”。这适用于再营销和重新唤醒活动。<br/><br/>" +
                        "通过深度链接，如果用户点击广告且已安装应用，应用将不仅被打开，还会直接跳转到您指定的内容页面，而不是默认首页。<br/><br/>" +
                        "提示：" +
                        "<ul>" +
                        "<li>如果您收到提示，要求设置 Android App Links 证书或 Team ID，说明您尚未在 <strong>应用</strong> 页面正确配置深度链接方案。</li>" +
                        "<li>要测试配置，请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360046951332-How-to-Test-a-Tracking-Link#How_to_Test_Deep_Linking'>如何测试深度链接</a>。</li>" +
                        "</ul><br/>" +
                        "<strong>变体：</strong>" +
                        "<ul>" +
                        "<li><strong>延迟深度链接</strong> 允许用户尚未安装应用时点击链接，在安装后仍能跳转至指定页面。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360031370991-Deep-Linking-FAQ?navigation_side_bar=true#what_are_deferred_deep_links'>了解更多</a>。</li>" +
                        "<li><strong>iOS 通用链接</strong> 和 <strong>Android 应用链接</strong> 是特定于操作系统的深度链接形式，根据用户的设备和历史偏好，将他们引导至应用或网页中的特定位置。详情请见 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360030934212-Singular-Links-Tracking-Links-FAQ#Deep_Linking_Terms_and_Concepts_iOS_Universal_Links'>深度链接 FAQ</a>。</li>" +
                        "</ul><br/>",
                    "RUN_REPORT": "在 Singular 中，您可以使用多种报告工具。<br/>" +
                        "<ol>" +
                        "<li><strong>仪表板</strong> - 创建自定义仪表板，整合下方各类报告数据。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/206241026'>仪表板 FAQ 与疑难解答</a></li>" +
                        "<li><strong>报告与洞察 > 报告</strong> - 提取常规广告活动的聚合报告。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/205046069-Reports-FAQ-and-Troubleshooting'>报告 FAQ 与疑难解答</a></li>" +
                        "<li><strong>报告与洞察 > 素材报表</strong> - 获取创意素材的表现数据。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115001862443-Creative-Reports-FAQ-and-Troubleshooting'>创意报告 FAQ</a></li>" +
                        "<li><strong>SKAdnetwork > 原始数据</strong> - 查看 iOS 14.3+ SKAdNetwork 活动的原始数据。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4408240139163-SKAdNetwork-Raw-Data-FAQ-and-Troubleshooting'>SKAN 原始数据 FAQ</a></li>" +
                        "<li><strong>SKAdnetwork > 报告</strong> - 查看 SKAdNetwork 活动的聚合报告。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4408232000795-SKAdNetwork-Reports-FAQ-and-Troubleshooting'>SKAN 报告 FAQ</a></li>" +
                        "<li><strong>报告与洞察 > 广告变现</strong> - 查看广告变现表现的聚合报告。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360022067552-Setting-Up-Ad-Monetization-Reporting'>广告变现分析 FAQ</a></li>" +
                        "<li><strong>防作弊</strong> - 查看被拒或可疑安装的报告，以及 Singular 如何保护您免受欺诈攻击。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360003121852-Fraud-Reports-and-Fraud-Logs-FAQ-and-Troubleshooting'>防作弊报告与日志 FAQ</a></li>" +
                        "</ol>" +
                        "除此之外，您还可以在 <strong>报告与洞察 > 导出日志<</strong> 中获取广告活动的原始数据。<br/>请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360001216992-Export-Logs-and-User-Level-Data-FAQ'>导出日志 FAQ</a>。",
                    "VISUALIZE_CAMPAIGNS": "Singular 仪表板是一款易用且灵活的数据可视化工具，可帮助您最大化数据价值。<br/><br/>" +
                        "<ul>" +
                        "<li><strong>快速上手</strong>：访问您的组织预设的仪表板，立即开始探索数据。点击此处访问 <a href='#/react/dashboard?default=true'>预设仪表板</a>。</li>" +
                        "<li><strong>自定义仪表板</strong>：您可以创建多个仪表板，通过各种可自定义的组件（如柱状图、饼图、表格等）和数据类型（报告、SKAdNetwork、创意等）展示所需数据。<a href='#/react/dashboard?new=true'>创建新仪表板</a>。</li>" +
                        "<li><strong>个性化布局</strong>：通过拖拽或调整组件大小，在灵活的网格中自由排列组件，打造专属仪表板。</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请参阅 <a  target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/206241026-Dashboard-FAQ-and-Troubleshooting'>仪表板 FAQ 与疑难解答</a>",
                    "COHORTED_EVENTS": "<p>购买、升级、注册等都是 Singular 可以帮助您追踪的用户行为事件。<br/>通过在应用中追踪关键事件，您可以根据重要 KPI 衡量营销效果。</p><br/>" +
                        "<p>如果您通过 Singular SDK 使用了标准事件（具有预定义名称的事件），这些事件会<strong>自动出现在</strong><strong>事件</strong>页面中，节省您的设置时间。<br/>我们建议尽量使用标准事件。<br/><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/7648172966299'>我们根据行业分类整理了常用事件列表，以及建议携带的属性，帮助您快速入门。</a></p><br/>" +
                        "如果您使用的是自定义事件，仍需手动在事件页面中添加。创建自定义事件步骤如下：" +
                        "<ol>" +
                        "<li>进入 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/singular-events'>设置 > 事件</a> 并停留在<strong>群组事件</strong>标签页。</li>" +
                        "<li>选择事件适用范围：是全局事件（适用于所有应用）还是特定应用事件。</li>" +
                        "<li>点击<strong>新建事件</strong>按钮，为事件命名，如“注册成功”。</li>" +
                        "<li>设置该事件是否为唯一事件（即是否每位用户仅记录一次）。</li>" +
                        "<li>在下方事件来源渠道列表中选择相关事件来源渠道（如“Singular”），并选择您希望汇总的事件名称（如来自您所有版本的App上报的 “SignUp”事件，后缀Count表示用于记录事件次数 ）。</li>" +
                        "<li>配置其他设置并保存事件。</li>" +
                        "</ol><br/>" +
                        "<strong>还有疑问？</strong>请查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/208385833'>事件常见问题</a>",
                    "REPORTS_AND_PIVOTS": "当您的广告活动上线后，就可以开始运行报表啦！<br/><br/>" +
                        "<strong>一些报表使用小贴士：</strong>" +
                        "<ul>" +
                        "<li>如遇某些网络的数据显示为 N/A，可以在帮助中心查阅对应网络的细节说明。参考 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/categories/360000139492-Singular-Analytics#Data Connectors in Detail'>数据连接器详细说明</a>。</li>" +
                        "<li><strong>保存报表：</strong>可以快速重复运行相同的报表，无需重复设置。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/218104323-Bookmarking-a-Report'>了解如何保存报表</a></li>" +
                        "<li><strong>分享报表：</strong>可以与未加入您 Singular 账户的用户（如代理商或媒体渠道）共享报表。查看 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360046877232-Shared-Reports-FAQ'>共享报表常见问题</a></li>" +
                        "<li><strong>未映射数据：</strong>当渠道未提供 Bundle ID 或站点 ID 等维度时，Singular 无法将数据映射至具体应用，因此这些数据会显示为 N/A。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360031705411-Unmapped-Data-FAQ'>了解详情</a></li>" +
                        "<li>想设置计算指标？请联系 Singular 客服协助设置。</li>" +
                        "</ul><br/>" +
                        "<strong>还有问题？</strong>请查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/205046069-Reports-FAQ-and-Troubleshooting?'>报表常见问题与排查指南</a>。",
                    "ADVANCED_REPORTING": "准备开启进阶模式？以下是一些高级报表功能，帮助您进一步自定义分析视角：" +
                        "<ul>" +
                        "<li><strong>对比报表：</strong>选择“对比两个时间段”，自动高亮显示营销活动的增减变化。</li>" +
                        "<li><strong>自定义维度：</strong>根据需求自定义新的维度。例如，可创建“渠道”维度（值包括“社交”、“搜索”、“展示”、“重定向”），或“投放经理”维度（值为成员姓名）。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/208578986'>了解自定义维度</a></li>" +
                        "<li><strong>广告系列属性：</strong>分析竞价策略变动对广告效果的影响。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360032548672'>了解广告系列属性</a></li>" +
                        "<li><strong>数据告警：</strong>设置告警，自动通知您广告活动中的异常变动或达到的重要里程碑。支持广告系列、Tracker 和 AdMon 维度。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/207429293--UPDATED-Alerts-FAQ-and-Troubleshooting'>了解数据告警</a></li>" +
                        "</ul><br/>" +
                        "<strong>想了解更多新功能？</strong>欢迎订阅我们的<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360061042971-Product-Updates'>产品更新</a>专栏。",
                    "RUN_ADDITIONAL_REPORT": "以下是 Singular 平台中您可以使用的其他报告类型概览：" +
                        "<ul>" +
                        "<li><strong>仪表板：</strong> 在仪表板中查看整体营销表现。可通过编辑指标自定义仪表板。详见<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/206241026-Dashboard-FAQ'>仪表板 FAQ</a>。</li>" +
                        "<li><strong>留存热力图：</strong> 想快速查看不同渠道的用户留存？前往留存报告。详见<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/208156336-Retention-FAQ'>留存 FAQ</a>。</li>" +
                        "<li><strong>目标：</strong> 设定预算目标并运行报告，检查是否能按时达成目标，或是否需要调整预算。详见<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/206975446-Goal-Management-FAQ'>目标管理 FAQ</a>。</li>" +
                        "<li><strong>导出日志：</strong> 正在测试广告活动或排查问题？导出日志功能允许您查看每一次点击、会话和安装数据。提示：使用尽可能多的筛选条件以获得更有针对性的数据。详见<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360001216992-Exporting-Attribution-Logs'>导出日志和用户级数据 FAQ</a>。</li>" +
                        "</ul>",
                    "EXPLORE_OTHER_WAYS": "Singular 提供多种程序化方式来提取数据。<br/><br/>例如，Reporting API 提供与报告页面和创意页面相同的数据访问能力。<br/><br/>您还可以设置 Internal BI 回传，将安装和应用内事件实时发送到您的内部 BI 平台。",
                    "REPORTING_API": "Singular Reporting API 可让您访问报告页面和创意报告页面中的全部数据。<br/><br/>在<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/testing-console'>Singular API 控制台</a>获取 API 密钥，然后查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/207553433-Guide-to-the-Singular-Reporting-API'>Reporting API 使用指南</a>。<br/><br/>" +
                        "<strong>使用提示：</strong>" +
                        "<ul>" +
                        "<li>为确保快速返回数据，建议按单日查询，并尽量添加筛选条件以减少数据量。</li>" +
                        "<li>使用<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/207553433-Guide-to-the-Singular-Reporting-API'>数据可用性</a>接口，确认某日是否已准备好数据。这有助于您安排实际的报告拉取时间。</li>" +
                        "<li>在<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/203389179-Metrics-and-Dimensions'>指标与维度词汇表</a>中了解字段定义。</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请参考<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360045245692-Reporting-API-Reference'>Reporting API 参考文档</a>或查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360045245692-Reporting-API-Reference'>常见问题</a>。",
                    "BI_POSTBACKS": "在跟踪和衡量营销成效时，Singular 的归因服务会将安装和事件信息通过 postback 回传给广告平台，用于其内部统计。<br/><br/>您也可以将这些 postback 配置为发送到内部 BI 系统。在 <strong>Partner Configuration</strong> 页面中找到“Internal BI”选项，并为每个应用设置对应的回传地址。<br/><br/>" +
                        "<strong>有疑问？</strong>请参考<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.singular.net/docs/partner-postbacks'>Internal BI Postbacks 指南</a>。",
                    "ETL": "Singular 可将数据直接导出至您的数据仓库、存储服务或 BI 平台，供您使用自定义工具进行处理与可视化分析。<br/><br/>" +
                        "<strong>提示：</strong>" +
                        "<ul>" +
                        "<li>选择所需的数据结构。参考<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360039511492'>聚合数据结构</a>或<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360048784092'>用户级数据结构</a>。</li>" +
                        "<li>一旦创建并保存了数据目的地，就无法更改其数据结构。如需更改，请创建新的目的地，可选择删除旧表或将新数据写入新表，确保数据安全性和查询的连续性。</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360037917571-Singular-Data-Destinations-ETL-FAQ'>数据目的地与 ETL FAQ</a>",
                    "SKAN_INTRO": "Apple 的 SKAdNetwork（SKAN）是用于衡量 iOS 用户广告效果的隐私保护框架。Singular 提供业内领先的 SKAN 支持，确保数据可靠且可操作。<br/><br/>" +
                        "<strong>整合 Singular 的 SKAN 支持可让您：</strong>" +
                        "<ul>" +
                        "<li>解密并聚合从 Apple 收到的安装数据</li>" +
                        "<li>与非 SKAN 数据并列报告，保持 KPI 连续性</li>" +
                        "<li>通过分析和对比模型提升广告效果</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请查看<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/sections/360010469792'>SKAN 支持中心文档</a>了解更多信息。",
                    "SKAN_FACEBOOK": "Facebook 的 SKAdNetwork 报告存在一些特有特性。Singular 提供两种对接方式：<br/><br/>" +
                        "<strong>1. 通过 Facebook 事件管理器：</strong> Facebook 向 Singular 提供 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4405149899281'>聚合 SKAdNetwork 报告</a>，供 Singular 加工后展示在报告页面中。此方法适用于无需从 Apple 获取原始 SKAN postback 的客户。<br/><br/>" +
                        "<strong>2. 通过 Apple 原始 postback：</strong> 对于需要完整原始 SKAN postback 的客户，Singular 可通过专用 URL 获取这些数据（如 Apple 所要求），前提是 Facebook 广告账户启用了 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4405252694545'>SKAN Data Enablement</a> 并配置了 Singular 提供的 endpoint。<br/><br/>" +
                        "<strong>提示：</strong>两种方法的数据在粒度和时间戳方面略有差异，建议与 Facebook 和 Singular 客服一起评估最佳对接方式。",
                    "SKAN_ADWORDS": "Google Ads 支持 SKAdNetwork 数据的自动集成。Singular 可以从 Google 获取聚合后的 SKAN 数据，并在报告中展示。<br/><br/>" +
                        "在 Google Ads 中启用 SKAdNetwork 报告后，Singular 将每日获取并聚合这些数据，展示在报告页面中的 <strong>Google (SKAdNetwork)</strong> 渠道下。<br/><br/>" +
                        "<strong>设置步骤：</strong>" +
                        "<ol>" +
                        "<li>前往 Google Ads 后台，确保已为目标广告系列启用 SKAN 报告</li>" +
                        "<li>在 Singular 中启用 Google SKAN 渠道</li>" +
                        "</ol><br/>" +
                        "更多详情请参阅<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/115003282452'>Google Ads 与 SKAdNetwork 集成指南</a>。",
                    "SKAN_CONVERSION_MODEL": "<strong>注意：</strong>SKAN 仅适用于 iOS<br/><br/>" +
                        "在通过 SKAdNetwork 跟踪用户活动时，我们依赖 <strong>转换值</strong> —— 一个在应用安装后由应用发送给广告网络的 0 到 63 之间的数字。<br/><br/>" +
                        "<strong>转换模型</strong> 是一种将尽可能多的安装后活动信息编码进有限转换值的方法。详情请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360052605611-SKAdNetwork-Model-Configuration-FAQ#General_Concepts_and_Planning'>SKAdNetwork 模型配置：常见概念与规划</a>。<br/><br/>" +
                        "您选择的转换模型将影响广告系列报告和优化效果。请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/categories/360004944071-iOS-14-and-SKAdNetwork#SKAdNetwork%20Partner%20Integrations'>SKAdNetwork 合作伙伴集成</a>。" +
                        "需要更多帮助？请查阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360052605611'>模型配置常见问题</a>。" +
                        "<br /><br/><strong>提示：</strong>" +
                        "<ul>" +
                        "<li>使用 SKAdNetwork 时，无法获得广告系列结果的各种数据。您必须根据最希望优化的某一种数据类型（如收入或互动）选择模型。</li>" +
                        "<li>若选择“转化事件”、“互动”或“漏斗”模型，您需要定义希望衡量的一组事件。这些事件必须在 SDK 集成中预先定义。</li>" +
                        "<li>若选择“漏斗模型”，您需按事件发生顺序定义事件列表。例如，在游戏应用中，事件可能为“达到第 2 级”、“达到第 5 级”、“达到第 10 级”等。</li>" +
                        "</ul><br />",
                    "SKAN_PROBABILISTIC": "当在 iOS 14 及以上版本中运行广告系列时，设备标识符不可用，归因可通过两种方式实现：SKAdNetwork（推荐方式）或概率归因。<br/><br/>" +
                        "在概率归因中，Singular 的追踪链接用于收集设备的基本信息，例如 IP 地址和设备型号。但从 iOS 14.5 起，由于隐私政策，概率归因仅适用于特定场景。<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360047706852#I_am_an_integrated_partner_supporting_mobile_web_inventory._What_do_I_have_to_prepare_for'>了解更多关于在 iOS 14 设备上使用概率归因</a>。<br/><br/>" +
                        "<strong>提示：</strong>" +
                        "<ul>" +
                        "<li>支持概率归因的合作伙伴可以使用 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360018879491#smtype'>source media type</a>（_smtype）链接参数。该参数可帮助 Singular 判断该点击是否可用于概率归因。</li>" +
                        "<li>如果您与这些合作伙伴合作，请联系他们确认是否符合新要求，或将他们引导至 Singular 的 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360047706852#I_am_an_integrated_partner_supporting_mobile_web_inventory._What_do_I_have_to_prepare_for'>合作方说明文章</a>。</li>" +
                        "<li>如果您运行概率广告系列，其数据将出现在常规报告页面（而非 SKAdNetwork 报告页面）。</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请查阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360002290752-Probabilistic-Attribution-FAQ'>概率归因常见问题</a>。",
                    "SKAN_REPORTING": "在您的应用中完成 SKAdNetwork 设置、配置好转换模型并等待部分数据收集后，您就可以开始分析结果。Singular 提供两种 SKAdNetwork 新报告：<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>SKAdNetwork 原始数据：</strong>查看 SKAdNetwork postback 中收到的原始安装数据（未解码）。</li>" +
                        "<li><strong>SKAdNetwork 报告：</strong>查看与广告网络成本、曝光和 CPI 结合后的 SKAdNetwork 数据。</li>" +
                        "</ol><br/>" +
                        "<strong>注意事项：</strong>" +
                        "<ul>" +
                        "<li>用户安装应用后，Apple 通常需 24 至 72 小时才会发送安装数据（即 SKAdNetwork postback）。因此，启动广告系列后需要一些时间才能看到数据。</li>" +
                        "<li><strong>Twitter 和 Google</strong> 通过专用 API 向 Singular 提供 SKAdNetwork 数据（不是直接转发原始 postback），因此无法通过导出日志下载这些网络的 postback 级数据。</li>" +
                        "<li><strong>Apple Search Ads 不使用 SKAdNetwork</strong> —— 它使用的是不同的广告归因机制。<strong>ASA 数据仍显示在常规报告中</strong>，即使是在 iOS 14.5+ 设备上。</li>" +
                        "<li>SKAdNetwork 框架不支持 web-to-app 安装或基于概率归因的安装（如交叉推广）。</li>" +
                        "</ul><br/>" +
                        "<strong>有疑问？</strong>请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4408232000795'>SKAdNetwork 报告常见问题</a>",
                    "ADMON_INTRO": "Singular 提供两种广告变现报告类型：广告变现分析 和 广告收入归因。<br/><br/>" +
                        "<strong>广告变现分析：</strong><br/>" +
                        "分析您的广告变现效果，包括填充的广告请求数、竞价请求/响应数以及汇总的广告收入。Singular 直接从您的变现渠道拉取汇总指标。请查找名称中包含“广告变现”的数据连接器。<br/><br/>" +
                        "更多详情请参阅 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/360022067552'>广告变现常见问题</a><br/><br/>" +
                        "<strong>广告收入归因：</strong><br/>" +
                        "广告收入归因将 SDK 广告收入事件与您的用户获取（UA）活动数据结合，为您提供广告投资回报率（ROI）的完整视图，" +
                        "广告活动成本、应用内收入和广告收入均汇总于一行。<br/><br/>" +
                        "广告收入归因通常基于您的媒介平台报告的展示级广告收入数据。Singular 支持多种广告收入归因方案。请查看 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/zh-cn/articles/4418187811611-Onboarding-Guide-for-Ad-Revenue-Attribution'>广告收入归因入门指南</a>。",
                    "ADMON_ANALYZE": "Singular 的广告变现分析让您追踪来自不同网络的汇总广告收入。Singular 每日直接从您的变现渠道拉取广告收入数据。<br/><br/>" +
                        "首先添加所有相关的广告变现数据连接器（名称中包含“广告变现”字样）。<br/><br/>" +
                        "充分利用报表功能，设置自定义维度、仪表盘等。<br/><br/>" +
                        "<strong>有疑问？</strong>请查看 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360022067552\">广告变现常见问题</a>",
                    "ADMON_SETUP_REVENUE": "您可以通过在 Singular SDK 实现中添加代码片段，从媒介平台获取广告收入归因数据。此方法允许 Singular 像处理其他 SDK 事件一样处理广告收入数据。<br/><br/>" +
                        "<strong>几点建议：</strong><br/>" +
                        "<ul>" +
                        "<li>您可以在报表和数据透视表中的分群指标下查看广告收入数据</li>" +
                        "<li>数据每小时更新一次</li>" +
                        "<li>导出日志中可查看用户级数据</li>" +
                        "<li>完成添加额外代码片段后，设置 SKAN 组合收入模型（包括广告收入事件）</li>" +
                        "<li>每个应用可以设置不同的媒介平台</li>" +
                        "</ul>" +
                        "<strong>请联系 Singular 代表以启用此功能。</strong>更多关于发送广告收入事件的信息，请参阅我们的 SDK 文档：" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360038723351#Adding_Ad_Revenue_Attribution_Support\">iOS</a>，" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360038645131#Adding_Ad_Revenue_Attribution_Support\">Android</a>，" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360038355151#Adding_Ad_Revenue_Attribution_Support\">Unity</a>。 " +
                        "请确保在上线前使用 SDK 控制台测试广告收入事件。<br/><br/>" +
                        "如果无法设置广告收入 SDK，Singular 还提供其他获取和计算广告收入的方式；请联系 Singular 代表了解详情。",
                    "ADMON_EXPORT": "广告变现分析和广告收入归因数据均可通过多种方式导出到您内部的 BI 表中：<br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li style=\"margin: 10px 0;\"><strong>API 集成</strong> 支持广告变现分析和广告收入 ROI 数据。" +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>您可以在 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360045674511\">帮助中心</a> 找到广告变现 API 的所有细节</li>" +
                        "<li>要查看包含 UA 来源的广告收入 ROI 统计数据，需从 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360045245692?#h_a89bb16a-6214-448f-b3ab-4443b20cc571\">分群指标</a> 接口拉取数据。</li>" +
                        "</ul></li>" +
                        "<li style=\"margin: 10px 0;\"><strong>数据目的地</strong> - Singular 会通过数据目的地自动将数据推送到您首选的数据仓库。设置广告变现架构以推送从变现渠道拉取的广告变现指标；详见 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360039511492#ad_monetization_data_schema\">广告变现分析架构</a></li>" +
                        "<li style=\"margin: 10px 0;\"><strong>BI 回传</strong> 支持 SDK 广告收入事件。了解如何配置 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/zh-cn/articles/360038040791\">BI 回传</a>。几点小贴士：<br/>" +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>SDK 事件列表包括 __IAP__ 和 __REVENUE__ 事件。</li>" +
                        "<li>__IAP__ 是指任何未指定自定义名称的应用内购买事件。</li>" +
                        "<li>__REVENUE__ 包括所有应用内购买事件及其他所有自定义收入事件，包括广告变现收入事件。</li>" +
                        "</ul></li>" +
                        "</ol>",
                    "GENERAL_AUDIT": `
                        运行一般步骤的审核报告，帮助您发现是否有操作错误。
                        该报告将检查您是否遗漏任何步骤，并提供最佳实践建议。
                        该报告可供任何标准用户或管理员用户使用。
                    `,
                    "SDK_AUDIT": `
                        审核您的 SDK 集成有助于发现集成中的错误或问题（包括 SDK 和 S2S）。
                        Singular 会审核最近 3 天内接收到的事件，帮助您发现潜在问题。
                        开发者可以结合测试控制台使用此报告，确保基础设置完成。
                    `
                },
                "BUTTON": {
                    "APPS": "添加应用",
                    "SDK_CONSOLE_BASIC_EVENTS": "进入 SDK 控制台",
                    "GET_STARTED_ADWORDS": "进入合作伙伴配置",
                    "SET_UP_GOOGLE": "添加数据连接器",
                    "SET_UP_FACEBOOK": "添加数据连接器",
                    "SET_UP_APPLE_SEARCH_ADS": "添加数据连接器",
                    "DATA_CONNECTORS": "添加数据连接器",
                    "RUN_REPORT": "运行报告",
                    "VISUALIZE_CAMPAIGNS": "创建仪表盘",
                    "COHORTED_EVENTS": "设置事件",
                    "PARTNER_CONFIGURATION": "配置合作伙伴",
                    "CUSTOM_DIMENSIONS": "添加自定义维度",
                    "SKAN_CONVERSION_MODEL": "添加转化模型",
                    "SKAN_REPORTING": "运行 SKAdNetwork 报告",
                    "BI_POSTBACKS": "添加 BI 回传",
                    "ETL": "添加数据目的地",
                    "TEST_LINKS": "进入导出日志",
                    "MANAGE_LINKS": "创建链接",
                    "CUSTOM_SOURCES_LINKS": "创建链接",
                    "DEEP_LINKING": "创建链接",
                    "REPORTING_API": "获取 API 密钥",
                    "SKAN_PROBABILISTIC": "添加链接",
                    "REPORTS_AND_PIVOTS": "运行报告",
                    "GENERAL_AUDIT": "运行通用审核",
                    "SDK_AUDIT": "运行 SDK 审核",
                    "ADMON_INTRO": "添加数据连接器",
                    "ADMON_SETUP_REVENUE": "运行报告",
                    "SDK_CONSOLE_TESTING": "进入测试控制台",
                    "EXPORT_DATA": "添加目的地",
                    "MARK_AS_DONE": "标记为已完成",
                    "SDK_INTEGRATION": "进入 SDK 规划",
                    "SHOW_KEYS": "显示密钥",
                    "HIDE_KEYS": "隐藏密钥"
                },
                "POPUP": {
                    "MARK_AS_DONE": {
                        "TEXT": "您确定要将此步骤标记为完成吗？此操作不可撤销",
                        "ACCEPT_TEXT": "标记为已完成"
                    }
                },
                "TOOLTIP": {
                    "AVAILABLE_AFTER_FIRST_STEP": "完成“规划入职流程”后，这些步骤将可用"
                },
                "BADGE": {
                    "ADDED": "已添加 ${count} 个"
                }
            },
            "SDK_CONFIGURATION": {
                "WELCOME_TEXT": "欢迎使用 Singular！",
                "SUMMARY_DONE_TITLE": "以下是您的对接计划：",
                "EDIT_PLAN_BUTTON": "编辑您的计划",
                "START_WIZARD_BUTTON": "开始使用",
                "SKIP_WIZARD_BUTTON": "跳过计划向导",
                "NEXT_BUTTON": "下一步",
                "CONTINUE_BUTTON": "继续入门",
                "DISABLED_QUESTION_LABEL": "不适用",
                "SKIP_POPUP": {
                    "BODY_TEXT": "您确定要跳过向导吗？跳过意味着我们将为您提供通用建议，并且无法准确帮助您验证设置。\n\n取消将带您返回向导。",
                    "ACCEPT_BUTTON": "是的，跳过",
                },
                "TOP_TEXT_1": "要开始入门，请告诉我们您的营销目标。<br/>我们将根据您的回答提供建议，否则将显示推荐的默认值。",
                "TOP_TEXT_2": "您可以随时返回并进行更改！",
                "PLATFORMS_STEP": {
                    "TITLE": "平台",
                    "PLATFORMS_QUESTION": {
                        "TEXT": "您将在哪些平台上进行营销？",
                        "HELP": "选择您计划在近期推广的平台"
                    },
                    "PLATFORM_LABEL_ANDROID": "Android",
                    "PLATFORM_LABEL_IOS": "iOS",
                    "PLATFORM_LABEL_PC": "PC/主机",
                    "PLATFORM_LABEL_WEB": "网页",
                    "SELECT_PLATFORM": "&bull; 至少选择一个平台",
                    "TOGGLE_OPTIONS": {
                        "YES": "是",
                        "NO": "否"
                    },
                    "DISABLED_PLATFORM_TOOLTIP": "您的计划不支持此平台",
                },
                "OTHER_SDKS_STEP_TITLE": "其他 SDK",
                "PRIVACY_STEP_TITLE": "用户隐私与同意",
                "CAMPAIGNS_CONFIG_STEP_TITLE": "投放网络与归因类型",
                "MONETIZATION_STEP_TITLE": "变现事件",
                "PLATFORMS_STEP_WIZARD_LABEL": "平台",
                "OTHER_SDKS_STEP_WIZARD_LABEL": "其他 SDK",
                "PRIVACY_STEP_WIZARD_LABEL": "用户隐私与同意",
                "CAMPAIGNS_CONFIG_STEP_WIZARD_LABEL": "投放网络与归因类型",
                "MONETIZATION_STEP_WIZARD_LABEL": "变现事件",
                "CATEGORIES": {
                    "PLATFORM_CATEGORY": "平台",
                    "OTHER_SDK_CATEGORY": "其他 SDK",
                    "USER_PRIVACY_CATEGORY": "用户隐私与同意",
                    "CAMPAIGN_TYPES_CATEGORY": "您将运行以下哪种类型的广告活动：",
                    "SINGULAR_TRACKING_LINKS_CATEGORY": "您是否为以下用途使用 Singular 追踪链接：",
                    "SINGULAR_FEATURES_USAGE_CATEGORY": "您是否会使用以下任何功能：",
                    "NETWORK_SPECIFIC_CATEGORY": "您是否将在以下网络投放广告",
                    "APP_MONETIZATION_CATEGORY": "您将如何对应用进行变现？",
                    "APP_MONETIZATION_CATEGORY_TOOLTIP": "告诉我们您应用使用的变现模式。",
                },
                "QUESTIONS": {
                    "YOUR_PLATFORMS": "您的平台",
                    "IS_USING_OTHER_MMP": "您是否正在使用其他 MMP？",
                    "IS_USING_OTHER_MMP_TOOLTIP": "您是否正在使用其他 MMP？",
                    "IMPORT_DATA_FROM_CURRENT_MMP": "我希望从之前的 MMP 导入历史数据",
                    "IS_USING_FIREBASE_SDK": "您是否正在使用 Firebase SDK？",
                    "IS_USING_META_SDK": "您是否正在使用 Facebook/Meta Ads SDK？",
                    "IS_TARGETING_CHILDREN": "您的应用是否面向儿童？或者有额外的用户隐私要求？",
                    "IS_TARGETING_CHILDREN_TOOLTIP": "Singular 提供额外的 SDK 和功能来管理用户数据限制的同时保留归因能力。",
                    "IS_RUNNING_SKAN_CAMPAIGNS": "SKAN",
                    "IS_SHOWING_ATT_PROMPT": "iOS - 是否会显示 ATT 提示？",
                    "IS_SHOWING_ATT_PROMPT_TOOLTIP": "App Tracking Transparency（ATT）是苹果的隐私政策变更，要求营销人员在追踪前获得用户同意。",
                    "IS_USING_DEEP_LINKING_TRACKING_LINKS": "深度链接或延迟深度链接？",
                    "IS_USING_DEEP_LINKING_TRACKING_LINKS_TOOLTIP": "深度链接追踪 URL 不仅会打开应用（如果已安装），还会跳转至应用内的特定页面，例如电商应用中的某一商品页面。",
                    "IS_USING_BI_POSTBACKS": "BI 回传",
                    "IS_RUNNING_RE_TARGETING": "再营销广告活动",
                    "IS_RUNNING_RE_TARGETING_TOOLTIP": "再营销广告活动帮助追踪已安装应用但长时间未活跃的用户。",
                    "IS_USING_TRACKING_LINKS_FOR_EMAIL_CAMPAIGNS": "电子邮件营销",
                    "IS_USING_TRACKING_LINKS_FOR_SMS_CAMPAIGNS": "短信营销",
                    "IS_RUNNING_INFLUENCER_CAMPAIGNS": "网红营销活动",
                    "IS_RUNNING_INFLUENCER_CAMPAIGNS_TOOLTIP": "您是否会为网红构建追踪链接？",
                    "IS_RUNNING_APPLE_SEARCH_ADS_CAMPAIGNS": "Apple Search Ads",
                    "IS_RUNNING_FACEBOOK_CAMPAIGNS": "Meta Ads/Facebook/Instagram",
                    "IS_RUNNING_GOOGLE_ADS_CAMPAIGNS": "Google Ads",
                    "IS_RUNNING_NETWORKS_WITH_TRACKING_LINKS": "使用追踪链接的广告网络",
                    "IS_RUNNING_NETWORKS_WITH_TRACKING_LINKS_TOOLTIP": "这类网络可能包括联盟平台或 SDK 网络，例如 Unity 和 Moloco",
                    "IS_APP_MONETIZING_SUBSCRIPTION_BASED": "基于订阅",
                    "IS_APP_MONETIZING_IN_APP_PURCHASE_BASED": "基于应用内购买",
                    "IS_APP_MONETIZING_IN_APP_PURCHASE_BASED_TOOLTIP": "应用内购买需在 SDK 中配置为收入事件，以便 Singular 计算 ROI",
                    "IS_AD_MONETIZATION_BASED": "广告变现",
                    "SELECT_MEDIATION_PLATFORM": "您使用哪个广告中介平台？",
                    "SELECT_MEDIATION_PLATFORM_TOOLTIP": "您的应用是否展示广告？",
                }
            },
            "SIDEBAR_PROGRESS_BAR": {
                "SDK_CONFIGURATION": "规划您的对接流程",
                "NEXT_STEP": "下一步",
                "APPS": "添加应用",
                "SDK_INTEGRATED": "集成 SDK",
                "SDK_CONSOLE_TESTING": "测试 SDK",
                "WEB_SDK_INTEGRATION": "网页归因",
                "COHORTED_EVENTS": "添加事件",
                "PARTNER_CONFIGURATION": "设置合作伙伴",
                "DATA_CONNECTORS": "添加数据连接器",
                "SKAN_CONVERSION_MODEL": "设置 SKAN 转化模型",
                "MANAGE_LINKS": "构建跟踪链接",
                "SET_UP_GOOGLE": "设置 Google Ads",
                "SET_UP_FACEBOOK": "设置 Meta Ads / Instagram",
                "SET_UP_APPLE_SEARCH_ADS": "设置 Apple Search Ads"
            },
            "ACCOUNT_PLAN": {
                "HEADER": "账户套餐",
                "PLAN_DETAILS": "套餐详情",
                "INSTALLS": "转化",
                "FREE_INSTALLS": "免费转化",
                "PAID_INSTALLS": "转化",
                "AD_SPEND": "广告花费",
                "TIMEZONE": "时区",
                "CURRENCY": "货币",
                "START_DATE": "开始日期",
                "EXPIRATION_DATE": "到期日期",
                "UNLIMITED": "∞ 无限制",
                "TIER": {
                    "TITLE": "套餐",
                    "FREE": "免费",
                    "FREE_STARTER": "入门版",
                    "STANDARD_UNIFIED": "增长版",
                    "TRIAL": "增长版试用",
                    "ENTERPRISE": "企业版"
                },
                "BLOCKED_ORF_ERROR_MSG": "<b>您已达到使用上限</b> 请立即升级套餐以恢复访问权限。",
                "PLAN_PRICE": "套餐价格",
                "YEARLY": "年度",
                "INSTALL_CAP": "归因转化上限",
                "INSTALL_CAP_FREE": "前 15,000 次转化免费！",
                "INSTALL_CAP_FREE_INFO": "随时购买更多配额。",
                "AD_SPEND_CAP": "广告花费上限",
                "NO_PLAN": "未找到有效套餐",
                "BE_IN_TOUCH": "谢谢！我们将尽快与您联系",
                "ADD_ONS": "附加功能（${value}/${total}）",
                "ADVANCED_COLLECT": "高级收集和洞察",
                "BADGE": {
                    "YOUR_PLAN": "您的方案"
                },
                "PERCENT_USED": "已使用 ${percent}%",
                "TOTAL_CONVERSIONS": "总转化数 ${percent}%",
                "PRICING_CARDS": {
                    "CONTAINER": {
                        "HEADER": "升级您的套餐"
                    },
                    "TITLE": {
                        "FREE": "入门版",
                        "STANDARD_UNIFIED": "增长版",
                        "ENTERPRISE": "企业版"
                    },
                    "DESCRIPTION": {
                        "FREE": "该套餐提供核心功能，并可通过预付转化实现最大灵活性。",
                        "STANDARD_UNIFIED": "该套餐包含技术集成支持和客户成功经理服务。",
                        "ENTERPRISE": "通过我们最全面的套餐驱动增长。"
                    },
                    "CTA": {
                        "FREE": "立即购买",
                        "STANDARD_UNIFIED": "联系销售",
                        "ENTERPRISE": "联系销售"
                    },
                    "PRICING": {
                        "FREE": "添加预付转化",
                        "STANDARD_UNIFIED": "$0.05 / 每次转化",
                        "ENTERPRISE": "获取定制方案"
                    },
                    "BODY": {
                        "FREE": "<ul style='padding-left: 16px'><li>付费即享客户支持</li><li>业内领先的移动归因</li><li>卓越的 ROI 分析与防欺诈</li><li>深度链接和自定义链接</li><li>SKAdNetwork 归因</li><li>强大的 API 接口</li><li>SKAdNetwork 分群预测</li><li>可自定义仪表板</li><li>创意报告</li></ul>",
                        "STANDARD_UNIFIED": "<b>包含入门版全部功能，并额外提供：</b><br><ul style='padding-left: 22px'><li>1 对 1 技术工程师支持</li><li>客户支持</li><li>受限用户访问管理</li></ul><br><b>可选增值功能：</b><br><ul style='padding-left: 22px'><li>零代码 ETL 与数据导出</li><li>广告收入归因与分析</li><li>Web 归因</li><li>Web CAPI 集成</li><li>PC 与主机支持</li></ul>",
                        "ENTERPRISE": "<b>包含增长版全部功能，并额外提供：</b><br><ul style='padding-left: 22px'><li>专属客户成功经理</li><li>企业级 SLA</li><li>跨设备归因</li><li>365 天分群支持</li><li>受众管理</li><li>高级权限管理</li><li>单点登录（SSO）</li><li>私有云（可选）</li></ul>"
                    },
                },
                "PACING_CARD": {
                    "TITLES": {
                        "CONVERSIONS": "转化进度",
                        "AD_SPEND": "广告花费进度"
                    },
                    "DESCRIPTION": {
                        "CONVERSIONS": "已追踪的归因转化",
                        "AD_SPEND": "已追踪的广告花费"
                    },
                    "INFORMATION": {
                        "NO_USAGE": "<b>恭喜！您的套餐包含 ${maxValue} 次免费转化！</b> 您可以继续使用 Singular。",
                        "USAGE": "<b>您的套餐还剩下 ${usageLeft} 次 ${valueType}！</b> 可随时升级套餐以继续使用 Singular。",
                        "MAXED_CAP": "<b>您已超出套餐限制 ${usageLeft} ${valueType} ${capType}！</b> 可随时升级套餐以继续使用 Singular。",
                        "DATE_EXPIRED": "<b>您的套餐还剩下 ${expiresInDays} 天！</b> 升级套餐以继续使用 Singular。",
                        "EXPIRED": "<b>您已超出套餐有效期 ${expiresInDays} 天！</b> 升级套餐以继续使用 Singular。",
                    },
                    "CAP_TYPE": {
                        "AD_SPEND": "广告花费",
                    },
                    "VALUE_TYPE": {
                        "CONVERSIONS": "转化",
                        "AD_SPEND": "USD",
                    }
                },
                "BUTTONS": {
                    "PLAN_DETAILS": "查看所有套餐详情",
                    "BUY_CONVERSIONS": "购买转化",
                    "SPEAK_TO_SALES":  "联系销售",
                    "LEARN_MORE": "了解更多",
                },
                "TOOLTIPS": {
                    "PACING_CARD": "已追踪的转化包括安装、重新激活或网页会话。在 iOS 上，我们会使用 SKAN 安装数和 Tracker 安装数中较高的值。",
                    "PLAN_DETAILS_START_DATE": "这是以下日期中较早者：您注册账户的日期，或最近一次付款日期（如适用）。",
                    "PROGRESS_BAR_MOBILE": "${percentage}% 移动端转化：${value}",
                    "PROGRESS_BAR_WEB": "${percentage}% 网页端转化：${value}",
                    "PROGRESS_BAR_PC_CONSOLE": "${percentage}% PC/主机端转化：${value}",
                },
                "CONVERSIONS": {
                    "MOBILE": "<b>移动端</b> (${value})",
                    "WEB": "<b>网页端</b> (${value})",
                    "PC_CONSOLE": "<b>PC/主机端</b> (${value})",
                },
                "FEATURE_STATUS": {
                    "CONTRACTED": "已签约",
                    "TRIAL": "试用",
                    "AVAILABLE": "可用",
                }
            }
        },
        "PAGE_HEADERS": {
            "AD_MONETIZATION": "广告收益报告（按渠道划分）",
            "ALERTS": "提醒",
            "API": "Singular API 接口",
            "APPS_CONFIGURATION": "配置应用",
            "ATTRIBUTION": "欢迎使用Singular归因解决方案<br/>跟踪用户行为数据",
            "AUDIENCE_DISTRIBUTIONS": "推送用户群组",
            "AUDIENCE_SEGMENTS": "创建用户群组",
            "CREATIVES": "素材报告",
            "CUSTOM_DIMENSIONS": "自定义维度",
            "CUSTOM_EVENTS": "自定义事件",
            "DASHBOARD": "数据总台",
            "DATA_CONNECTORS": "数据连接器",
            "EDIT_ALERT": "编辑提醒",
            "EDIT_GOAL": "编辑目标",
            "EXPORT_LOGS": "导出日志",
            "FRAUD_DASHBOARD": "假量侦测综合报告",
            "FRAUD_PROTECTED": "可信流量报告",
            "FRAUD_REJECTED": "屏蔽流量报告",
            "FRAUD_SUSPICIOUS": "可疑流量报告",
            "GENERATE_LINK": "创建跟踪链接",
            "GOAL_MANAGEMENT": "管理目标",
            "NEW_ALERT": "创建新提醒",
            "NEW_GOAL": "创建新目标",
            "DUPLICATE_GOAL": "创建新目标",
            "PIVOT": "数据透视报表",
            "REPORTS": "自定义报告",
            "RETENTION": "留存报告",
            "SDK_CONSOLE": "SDK测试控制台",
            "TWO_FACTOR_AUTH": "双重认证",
            "TWO_FACTOR_AUTH_CONFIG": "配置双重认证",
            "WEB_TRACKING_LINKS": "创建网页跟踪链接",
            "PARTNER_CONFIGURATION": "配置渠道",
        },
        "PAGE_MESSAGES": {
            "NO_APPS_CONFIGURED_PLEASE_CONFIGURE": "系统尚未侦测到任何事件，请先查看是否已按照要求配置SDK，如有疑问请联系技术支持。"
        },
        "PLACEHOLDERS": {
            "CURRENT_PASSWORD": "当前密码",
            "NEW_PASSWORD": "新密码",
            "SELECT_EVENT": "选择自定义事件",
            "SELECT_FILTER": "选择过滤项",
            "SELECT_GOAL": "选择已创建的目标",
            "SELECT_OS": "选择系统",
            "SELECT_PERIOD": "选择群组期间",
            "SELECT_PLATFORM": "选择平台",
            "SELECT_SOURCE": "选择渠道"
        },
        "SHOW_CHART_TOP_ROWS1": "显示前",
        "SHOW_CHART_TOP_ROWS3": "显示前",
        "SHOW_CHART_TOP_ROWS5": "显示前",
        "SOURCE_DIMENSIONS": "渠道维度",
        "SOURCE_METRICS": "渠道指标",
        "TIME_BREAKDOWN": "时间细分模式",
        "TOOLTIPS": {
            "MARK_FAVOURITE_APP": "添加收藏"
        },
        "TOPBAR_HEADERS": {
            "BOOKMARKS": "已保存的书签",
            "CHANGE_PASSWORD": "修改密码",
            "LOGOUT": "退出账户",
            "TWO_FACTOR_AUTH": "双重认证",
            "ACCOUNT_PLAN": "账户方案",
            "MANAGE_USERS_AND_AGENCIES": "用户 & 代理商"
        },
        "WIDGET_TITLE": "项目名称"
    },
    "API": "API",
    "Alerts": "提醒",
    "Analytics": "数据分析",
    "Attribution": "归因配置",
    "Automation": "自动化",
    "Custom Events": "自定义事件",
    "SDK Console": "SDK测试控制台",
    "SDK Keys": "SDK密钥",
    "Team Management": "管理用户",
    "My Dashboards": "我的仪表板",
    "Reports & Insights": "报告与洞察",
    "Pivot": "透视表",
    "Unified iOS": "iOS联合报表",
    "Creatives": "素材报表",
    "Campaign Report": "广告系列报告",
    "Cross Device": "跨设备",
    "Ad Monetization": "广告变现",
    "Retention": "留存",
    "Goals": "目标",
    "Media Mix Modeling": "媒体组合建模",
    "Multi-Touch": "多触点归因",
    "Assisted Installs": "辅助安装",
    "Export Logs": "导出日志",
    "Creative IQ": "素材IQ",
    "Creative Gallery": "素材库",
    "Creative Explore": "素材探索",
    "SKAdnetwork": "SKAdnetwork",
    "Raw Data": "原始数据",
    "Reports": "报告",
    "Model Configuration": "模型配置",
    "Benchmarks": "行业基准",
    "Market Snapshot": "市场概览",
    "Cost Portfolio": "成本组合",
    "Network Optimization": "渠道优化",
    "Audiences": "受众共享",
    "Segments": "用户群体",
    "Distributions": "投放分发",
    "Incrementality Tests": "增量测试",
    "Fraud Prevention": "防欺诈",
    "Dashboard": "仪表板",
    "Rejected Report": "被拒报告",
    "Suspicious Report": "可疑报告",
    "Protected Report": "受保护报告",
    "Global Settings": "全局设置",
    "Custom Rules": "自定义规则",
    "Banners": "横幅",
    "Attribution Setup": "归因设置",
    "Manage Links": "管理链接",
    "Partner Configuration": "配置渠道",
    "View Links": "查看链接",
    "Create Link": "创建链接",
    "Create Custom Link": "创建自定义链接",
    "Create Web Link": "创建网页链接",
    "Data Integrations": "数据集成",
    "Data Connectors": "数据连接器",
    "Data Destinations": "数据目的地",
    "Data Customization": "数据定制",
    "Custom Dimensions": "自定义维度",
    "Governance Schema": "治理架构",
    "Governance Codes": "治理代码",
    "Partner Fees": "渠道费用",
    "Static": "静态",
    "Creative Tags": "创意标签",
    "CPI Configuration": "CPI配置",
    "Settings": "设置",
    "Apps": "应用",
    "Data Alerts": "预警配置",
    "Events": "事件",
    "Usage": "用法",
    "Developer Tools": "开发者工具",
    "Reporting API Keys": "报告API密钥",
    "Testing Console": "测试控制台",
    "SDK Integration": "SDK集成",
    "Help Center": "帮助中心",
    "Product Updates": "产品更新",
    "Admin": "管理员",
    "Invite": "邀请",
    "Custom Metrics": "自定义指标",
    "Manual Upload": "手动上传",
    "Partner Integration": "渠道对接",
    "Singular Admin": "Singular管理员",
    "Ad Network Access": "广告网络访问",
    "Onboarding Guide": "对接指南",
};

languages['cn'] = cn;

module.exports = cn;
